const translationsRu = {
    "status": "success",
    "data": {
        "lang": "ru_RU",
        "app": "hotel",
        "translation": {
            "liveBooking": {
  bookingMovedToOperationsMessage:
    'Ваше бронирование успешно обработано и передано нашей операционной команде для подтверждения поставщиком.',
  pleaseWaitSupplierApproval:
    'Пожалуйста, подождите, пока поставщик рассмотрит и подтвердит ваше бронирование. Обычно это занимает несколько часов.',

  waitingSupplierApproval: 'ОЖИДАЕТ ПОДТВЕРЖДЕНИЯ ПОСТАВЩИКОМ',
  youWillBeNotified:
    'Вы получите уведомление по электронной почте, как только поставщик ответит.',
                                "processingYourBooking": "Обработка вашего бронирования...",
                "stepCompletedSuccessfully": "Шаг успешно завершён",
                "somethingWentWrongOurTeamIsWorkingOnIt": "Что-то пошло не так. Наша команда уже работает над этим.",
                "stepCouldNotBeCompleted": "Не удалось завершить шаг.",
                "stillProcessingPleaseWait": "Обработка продолжается, пожалуйста, подождите...",
                "waitingForSupplierApproval": "Ожидание подтверждения поставщика",
                "stepAlreadyCompleted": "Шаг уже завершён.",
                "REVALIDATE": "Повторная проверка",
                "RESERVATION": "Бронирование",
                "SUMMARY": "Сводка",
                "PAYMENT_FINALIZATION": "Завершение оплаты",
                "bookingProcessStatus": "Статус процесса бронирования",
                "order": "Заказ",
                "lastUpdate": "Последнее обновление",
                "liveStreamingNotAvailable": "Прямая трансляция недоступна — используется резервный опрос. Если проблема сохраняется, наша операционная команда проверяет ситуацию.",
                "noProgressAvailable": "Пока нет информации о ходе бронирования.",
                "paymentNotRequired": "Оплата не требуется для этого бронирования (выбрана опция «Оплатить позже»)",
                "paymentProcessed": "Платёж обработан",
                "transactionId": "ID транзакции:",
                "processingOrderLevelJob": "Обработка задачи на уровне заказа",
                "emailSentToCustomer": "Письмо отправлено клиенту",
                "status": "СТАТУС",
                "retries": "ПОВТОРНЫЕ ПОПЫТКИ",
                "eta": "ОЖИДАЕМОЕ ВРЕМЯ",
                "timestamp": "ВРЕМЕННАЯ МЕТКА",
                "processing": "В обработке",
                "currentAttempt": "ТЕКУЩАЯ ПОПЫТКА",
                "of": "из",
                "failedToProcess": "Не удалось обработать",
                "supplierApiDidNotRespond": "API поставщика не ответил в установленный срок.",
                "attempts": "ПОПЫТКИ",
                "duration": "ДЛИТЕЛЬНОСТЬ",
                "failedAt": "ОШИБКА НА",
                "retryAvailable": "Повторная попытка доступна",
                "retryStep": "Повторить шаг",
                "waitingForRetry": "Ожидание повторной попытки после временной проблемы.",
                "etaForRetry": "Ожидаемое время повторной попытки:",
                "awaitingPreviousStep": "Ожидание завершения предыдущего шага",
                "paymentWillBeProcessed": "Оплата будет обработана далее",
                "emailQueued": "Уведомление по электронной почте поставлено в очередь",
                "willBeSentAfterPayment": "Будет отправлено после подтверждения оплаты",
                "processFailedAtStep": "Процесс завершился с ошибкой на шаге",
                "processingStep": "Обработка шага",
                "system": "Система",
                "bookingConfirmed": "Бронирование подтверждено!",
                "orderApprovedSuccessfully": "Ваш заказ успешно одобрен.",
                "sentItineraryToEmail": "Мы отправили маршрут на вашу электронную почту.",
                "orderConfirmed": "Заказ подтверждён",
                "allSystemsGo": "Все системы работают!",
                "orderNumber": "Номер заказа",
                "confirmation": "Подтверждение",
                "sentToEmail": "Отправлено на электронную почту",
                "checkYourInbox": "Проверьте входящие",
                "completeItinerarySent": "Полный маршрут и детали бронирования отправлены на ваш зарегистрированный адрес электронной почты.",
                "orderBeingProcessed": "Ваш заказ сейчас обрабатывается.",
                "orderWaitingForSupplier": "Ваш заказ сейчас ожидает одобрения поставщика.",
                "errorProcessingStep": "Произошла ошибка при обработке этого шага.",
                "pending": "в ожидании",
                "awaitingProcessing": "Ожидание обработки.",
                "skipped": "пропущено",
                "stepNotRequired": "Этот шаг не требовался для вашего бронирования.",
                "completed": "завершено",
                "processSteps": "Этапы процесса",
                "stepsCompletedSuccessfully": "этапы успешно завершены",
                "allDone": "Готово",
                "failed": "Ошибка",
                "inProgress": "В процессе",
                "loadingStatus": "Загрузка статуса",
                "okay": "Хорошо",
                "approved": "Одобрено"
                },

            "crud": {
                "updatedSuccessfully": "Успешно обновлено",
                "validationFailed": "Проверка не прошла",
                "operationError": "Произошла ошибка",
                "emptyList": "Данные не найдены",
                "failToLoad": "Ошибка при загрузке",
                "modelNotFound": "Не найдено"
            },
            "updateCard": {
                "payment_failed_please_update_card": "Payment failed - please update card",
                "open_the_payment_form": "Open the payment form",
            },
            "auth": {
                authTypeWarning: 'Пожалуйста, свяжитесь с операционной командой, чтобы включить членство — тип аутентификации не определён',
                authTitle: "Аутентификация по ID и мобильному телефону",
                pleaseLogin: "Пожалуйста, войдите с вашими учетными данными",
                verify: "Проверить",
                id: "Идентификатор",
                idPlaceholder: "Введите ваш идентификатор",
                idPlaceholderError: "Пожалуйста, введите ваш идентификатор",
                idDigits: "Идентификатор должен состоять из 9 цифр",
                phone: "Телефон",
                phonePlaceholderError: "Пожалуйста, введите ваш номер телефона",
                phoneDigits: "Номер телефона должен состоять из 9 цифр",
                phonePlaceholder: "Введите ваш номер телефона",
                send: "Отправить",
                authModalTitle: "Аутентификация по идентификатору и мобильному телефону",
                loginLoaeder: "Вход в систему...",
                loginError: "Ошибка входа. Пожалуйста, попробуйте снова.",
                otpLoader: "Проверка одноразового пароля...",
                loginSuccess: "Успешный вход в систему",
                otpError: "Ошибка проверки одноразового пароля. Пожалуйста, попробуйте снова.",
                otpStartOver: "Не получили код? Начните заново",
                register: "Регистрация",
                firstName: "Имя",
                lastName: "Фамилия",
                email: "Электронная почта",
                firstNamePlaceholder: "Введите ваше имя",
                lastNamePlaceholder: "Введите вашу фамилию",
                emailPlaceholder: "Введите вашу электронную почту",
                firstNamePlaceholderError: "Пожалуйста, введите ваше имя",
                lastNamePlaceholderError: "Пожалуйста, введите вашу фамилию",
                emailPlaceholderError: "Пожалуйста, введите вашу электронную почту",
                emailInvalid: "Пожалуйста, введите действительный адрес электронной почты",
                nameMinLength: "Имя должно содержать не менее 2 символов",
                registerButton: "Зарегистрироваться",
                backToLogin: "Вернуться к входу",
                registrationSuccess: "Регистрация успешна",
                registrationSuccessMessage: "Ваша регистрация прошла успешно",
                registrationError: "Регистрация не удалась. Пожалуйста, попробуйте снова.",
                dontHaveAccount: "Не имеете аккаунта?",
                registerHere: "Зарегистрироваться здесь",
                authWithMobile: "Аутентификация с мобильным телефоном",
                registerWithMobile: "Регистрация с номером мобильного телефона",
                loginTitle: "Войдите, чтобы продолжить",
                loginDescription: "Чтобы забронировать или управлять заказом, подтвердите свой номер телефона. Это займет меньше минуты.",
                otpInfo: "Мы отправим одноразовый код (OTP). Пароль не нужен.",
                whyLogin: "Зачем мне входить?",
                newHere: "Впервые здесь?",
                createAccount: "Создать аккаунт",
                sendCode: "Отправить код",
                privacyNotice: "Мы никогда не передадим ваш номер. Могут применяться тарифы SMS.",
                mobileNumber: "Номер мобильного",
                accountNotFound: "Аккаунт не существует",
                continueWithRegistration: "Хотите продолжить регистрацию?",
                continueRegistration: "Продолжить регистрацию",
                cancel: "Отмена",
                registrationStepIndicator: "ШАГ 2 ИЗ 2 — ВВЕДИТЕ ДАННЫЕ",
                createYourAccount: "Создайте аккаунт",
                registrationDescription: "Создайте аккаунт, чтобы быстрее оформлять бронирования и отслеживать заказы.",
                mobileHelper: "Мы используем его для отправки кода подтверждения.",
                emailHelper: "Необязательно — для получения ваучеров и обновлений.",
                agreeToTerms: "Я согласен с",
                terms: "Условиями",
                and: "и",
                privacyPolicy: "Политикой конфиденциальности",
                alreadyHaveAccount: "Уже есть аккаунт?",
                logIn: "Войти",
                agreeToTermsError: "Пожалуйста, согласитесь с условиями и политикой конфиденциальности",
                subscribeNewsletter: "Подпишитесь на нашу новостную рассылку",
                newsletterEmailRequired: "Пожалуйста, введите вашу электронную почту, чтобы подписаться на новостную рассылку",
                updateProfile: "Обновить профиль",
                logout: "Выйти",
                updateProfileSuccess: "Профиль обновлен",
                updateProfileSuccessMessage: "Ваш профиль успешно обновлен.",
                updateProfileError: "Не удалось обновить профиль. Попробуйте снова.",
                close: "Закрыть",
            },

            "upgradePlan": {
                "general": {
                    "upgrade_plan": "План обновления",
                    "upgrade_plan_to_regular": "Обновить до обычного плана",
                    "upgrade_plan_to_pro": "Обновить до плана PRO",
                  },
                "regular": {
                    "title": "Обновите сейчас и получите доступ к продуктам Agent 360!",
                    "benefits_title_text": "В настоящее время вы подключены к пакету Agent 360 Light. Если вы обновитесь, вы сможете получить",
                    "text_1": "Оптовые продукты Sky 360",
                    "text_2": "Отели для всех направлений по всему миру",
                    "text_3": "Регулярные и бюджетные рейсы",
                    "text_4": "Достопримечательности по всему миру",
                    "button_text": "Обновите сейчас до Agent 360!"
                },
                "pro": {
                    "title": "Обновите сейчас и получите веб-сайт для вашего бизнеса с полным брендингом!",
                    "benefits_title_text": "В пакете SKY 360 Pro вы можете наслаждаться",
                    "text_1": "Веб-сайт с вашим уникальным доменом",
                    "text_2": "Брендинг бизнеса - логотип и цвета сайта",
                    "text_3": "Продвижение пакетов и рейсов на сайте по направлениям",
                    "text_4": "Все бронирования будут принадлежать вашему агентству!",
                    "button_text": "Обновите сейчас до Pro!"
                }
            },

            "checkout": {
                "cityOfBirth": "Город рождения",
                "nationalityCountryId": "Страна гражданства",
                 "fill_out_at_least_one_guest_fields": "Пожалуйста, заполните все поля хотя бы для одного гостя!",
                "addRestOfGuests": "Add Rest Of Guests",
                "hideRestOfGuests": "Hide Rest Of Guests",
                "addBaggage": "Добавить багаж",
                "newGuest": "Новый гость",
                "selectGuest":"Выбрать гостя",
                "chooseExistingGuest": "Использовать существующего гостя",
                "additionalBaggage": "Дополнительный багаж",
                "free": "бесплатно",
                "baggageIsForBothFlights": "Вы можете добавить багаж для рейса туда и обратно",
                "additionalBaggageForThisGuest": "Дополнительный багаж для этого гостя",
                "orderFailedToLoad": "Произошла ошибка при загрузке предложения",
                "cartNoLongerValid": "Корзина больше не действительна",
                "room": "Комната",
                "personalInfo": "Детали заказа",
                "paymentDetails": "Оплата",
                "orderCompletion": "Завершить заказ",
                "userDetails": "Информация о клиенте",
                "name": "Имя",
                "lastName": "Фамилия",
                "passport": "Паспорт",
                "inEnglish": "",
                "birthdate": "Дата рождения",
                "phone": "Телефон",
                "email": "Электронная почта",
                "notesForTheOrder": "Заметки по заказу",
                "namesOfGuests": "Пассажиры",
                "namesMustMatchPassport": "* Все имена должны быть введены на английском языке точно так же, как в паспорте",
                "goToPayments": "Подтвердить и перейти к оплате",
                "saveAndCommit": "Сохранить и подтвердить предложение",
                "saveAndPayLater": "Сохранить и оплатить позже",
                "saveOrder": "Сохранить заказ",
                "agreement": "Я подтверждаю условия сайта, условия заказа и условия отмены заказа",
                "men": "Мужчина",
                "women": "Женщина",
                "pleaseInputYourPhone": "Пожалуйста, введите номер телефона",
                "pleaseInputYourLastName": "Пожалуйста, введите вашу фамилию",
                "pleaseInputYourFirstName": "Пожалуйста, введите ваше имя",
                "pleaseInputYourEmail": "Пожалуйста, введите вашу электронную почту",
                "pleaseInputYourPassportNumber": "Пожалуйста, введите номер паспорта",
                "pleaseInputYourDateOfBirth": "Пожалуйста, введите дату рождения",
                "pleaseSelectGender": "Пожалуйста, выберите пол",
                "maxChildAge": "Ребенок в возрасте от 2 лет",
                "maxInfantAge": "Младенцы должны быть младше двух лет на момент поездки",
                "pleaseAgreeWithT&C": "Пожалуйста, согласитесь с условиями использования и правилами сайта",
                "viewTerms": "Просмотреть правила",
                "invalidEmail": "Недействительный адрес электронной почты",
                "orderCreateSuccess": "Ваш заказ успешно сохранен, идет перенаправление на оплату",
                "orderCreateFree": "Ваш заказ успешно сохранен!",
                "orderUpdateSuccess": "Ваш заказ успешно обновлен!",
                "mainRoomGuestTitle": "Комната названа в честь",
                "uploadPassportImage": "Загрузить фото паспорта",
                "addInfant": "Добавить младенца",
                "updateInfant": "Обновить количество младенцев",
                "howManyInfantsDoYouWantToAdd": "Выберите количество младенцев для этой комнаты",
                "add": "Добавить",
                "setInfantCountForRoom": "Обновить количество младенцев",
                "setInfantCountForRoomSuccess": "Количество младенцев успешно обновлено",
                "infantsAddedToTheRoom": "Младенцы добавлены в комнату",
                "selectNumberOfInfants": "Выберите количество младенцев",
                "pricePerInfant": "Цена за младенца",
                "infantsRemoved": "Младенцы удалены из этой комнаты",
                "requiredUploadPassportImage": "Загрузка фото паспорта обязательна",
                "infantError4403": "Невозможно изменить количество младенцев - пожалуйста, свяжитесь с центром обслуживания",
                "docketId": "* Идентификатор дела",
                "agencyId": "* Идентификатор агентства",
                "documentType": "Тип документа",
                "documentTypeInfo": "Выберите ID карту для внутренних рейсов",
                "documentTypePassport": "Паспорт",
                "documentTypeIdCard": "ID карта",
                "issuingCountry": "Страна выдачи",
                "residenceCountry": "Страна проживания",
                "nationality": "Национальность",
                "documentNumber": "Номер документа",
                "documentNumberPassport": "Номер паспорта",
                "documentNumberIdCard": "Номер ID карты",
                "pleaseInputPassportNumber": "Пожалуйста, введите номер паспорта",
                "pleaseInputIdCardNumber": "Пожалуйста, введите номер ID карты",
                "expirationDate": "Дата истечения",
                "pleaseSelectDocumentType": "Пожалуйста, выберите тип документа",
                "pleaseSelectIssuingCountry": "Пожалуйста, выберите страну выдачи",
                "pleaseSelectResidenceCountry": "Пожалуйста, выберите страну проживания",
                "pleaseSelectNationality": "Пожалуйста, выберите национальность",
                "pleaseInputDocumentNumber": "Пожалуйста, введите номер документа",
                "pleaseSelectExpirationDate": "Пожалуйста, выберите дату истечения"
            },
            "manageOrder": {
                moveToPaymentWarning: 'Информация о клиенте не сохранена, а информация о гостях пуста! Вы уверены, что хотите продолжить?',
                moveToPaymentWarning1: 'Информация о клиенте не сохранена. Вы уверены, что хотите продолжить?',
                moveToPaymentWarning2: 'Информация о гостях пуста! Вы уверены, что хотите перейти к оплате?',
                "questions": "Вопросы",
                "moveToPayment": "Добавить оплату",
                "backToManage": "Вернуться к заказу",
                "paymentTitle": "Оплата заказа",
                "manageTitle": "Обновить информацию о заказе",
                "modelNotFound": "Заказ не найден",
                "failToLoad": "Не удалось загрузить данные заказа, пожалуйста, попробуйте позже.",
                "orderId": "Управление заказом",

                "room_booking_cancelled_successfully": "Бронирование номера успешно отменено",
                "room_booking_cancel_error": "Ошибка при отмене бронирования номера",
                "cancel_room_booking_warning": "Отменяя бронирование номера, вы потеряете бронирование и цену. Вы уверены?",
                "cancel_booking": "Отменить бронирование",
                "incompleteDPsWereRemoved": 'Неполные динамические пакеты были удалены из вашей корзины. Пожалуйста, добавьте их снова с отелем+рейсом и билетами на мероприятие.',
            },


            "attractionQuestions": {
                "customerInfo": "Customer Info",
                "participantsInfo": "Participants Info",

                "first_name": "First Name",
                "last_name": "Last Name",
                "email_address": "Email Address",
                "phone_number": "Phone Number",
                "pickup_location": "Pickup Location",
                "height_in_centimeters": "Height in Centimeters",
                "weight_in_kilograms": "Weight in Kilograms",
            },

            "completionForm": {
                "paymentFinish": {
                    "title": "Заказ успешно создан - оплата завершена",
                    "info": "На вашу адресу отправлено электронное письмо с деталями заказа"
                },
                "waitingToApprove": {
                    "title": "Ваш заказ отправлен на одобрение",
                    "info1": "Детали заказа сохранены в системе и отправлены на одобрение.",
                    "info2": "Оплата будет произведена только после одобрения заказа.",
                    "info3": "На вашу адресу отправлено электронное письмо с подтверждением заказа и оплатой."
                },
                "paymentFail": {
                    "title": "Оплата не прошла",
                    "info1": "Оплата не прошла :(",
                    "infoFail": "После нескольких попыток оплата не прошла - пожалуйста, попробуйте еще раз",
                    "infoWhatsapp": "Если произошла ошибка и вы не можете оплатить, пожалуйста, свяжитесь через WhatsApp по адресу: "
                },
                "orderNum": "Номер заказа",
                "thanksForChoose": "Спасибо за выбор",
                "free": {
                    "title": "Регистрация прошла успешно",
                    "info": "На вашу адресу отправлено электронное письмо с суммой заказа"
                },
                "pay_later": {
                    "title": "Регистрация прошла успешно",
                    "info": "На вашу адресу отправлено электронное письмо с подтверждением заказа"
                }
            },
            "paymentForm": {
                "card": "Кредитная карта",
                "creditCardInterest": "Процент кредитной карты",
                "interest": "процент",
                "monthlyPayments": "Платежи в месяц",
                "monthsCount": "Количество месяцев",
                "priceCanNotBeOverBalance":"Цена не может превышать баланс",
                "total":"Общая ссылка",
                "balance":"Общая сумма",
                "updatedBalance":"Обновленная сумма",
                "copyLink":"Скопировать ссылку",
                "linkFor":"Ссылка для",
                "back":"Назад",
                "setSpecificPrice":"Ссылка для оплаты",
                "createLink":"Создать ссылку",
                "setPriceAndSendPaymentLinkToClient":"Установить цену и отправить ссылку для оплаты клиенту",
                "clientName": "Client Name",
                "paymentPageFor": "Страница оплаты для",
                "forPayment": "Для оплаты",
                "price": "Цена",
                "copyPaymentLink": "Скопировать ссылку для оплаты",
                "pleaseFillInBothFields": "Пожалуйста, заполните оба поля.",
                "paymentLinkCopiedToClipboard": "Ссылка для оплаты скопирована в буфер обмена!",
                "createLinkForPrice": "Создать ссылку для оплаты",
                "creditNotSaveInBd": "Данные кредитной карты не сохраняются на сайте - вы совершаете безопасную оплату",
                "title": "Введите способ оплаты (только Visa и Mastercard)",
                "splitBtn": "Нажмите для разделения кредитных карт",
                "splitTitle": "Разделить кредитные карты",
                "splitDesc": "Выберите количество кредитных карт для разделения и нажмите подтвердить",
                "noSplit": "Без разделения",
                "noPayments": "Без оплаты",
                "payments": "Платежи",
                "paymentsNum": "Количество платежей",
                "withDebit": "С кредитом",
                "splitBy": "Кредитные карты",
                "toPay": "К оплате",
                "splitApprove": "Подтвердить",
                "currencyRate": "Оплата производится в шекелях - по туристическому курсу",
                "splitCurrentCardNum": "Разделить по карте",
                "splitCurrentCardNumFrom": "Из",
                "errorMessageToRetry": "Попытка № {retryNum} - Оплата не прошла от компании кредитных карт. Пожалуйста, введите данные карты снова или другую карту. Сайт принимает только карты VISA и MASTERCARD.",
                "installments": "Разстрочка",
                "installmentsLabel": "Количество разстрочек",
                "installmentFee": "Комиссия за разстрочку",
                "totalToPay": "Всего к оплате",
                "perMonth": "на месяц",
                "installmentsDisclosure": "Разстрочка обрабатывается эмитентом вашей карты. Общая сумма включает комиссию за разстрочку.",
            },

            "contactUs": {
                "requestForQuotation": "Запрос на предложение",
                "problemWithExistingOrder": "Проблема с существующим заказом",
                "customerService": "Обслуживание клиентов",
                "other": "Другое",
                "messageReceivedSuccessfully": "Сообщение успешно получено",
                "email": "Электронная почта",
                "phone": "Телефон",
                "fullName": "Полное имя",
                "writeUsMessage": "Напишите нам сообщение",
                "send": "Отправить",
                "phoneRequired": "Пожалуйста, введите номер телефона",
                "emailRequired": "Пожалуйста, введите адрес электронной почты",
                "fullNameRequired": "Пожалуйста, введите полное имя",
                "messageRequired": "Пожалуйста, введите сообщение",
                "nameMinLength": "Имя должно содержать не менее 2 символов",
                "emailInvalid": "Пожалуйста, введите действительный адрес электронной почты",
                "subjectRequired": "Пожалуйста, выберите тему",
                "selectSubject": "Выберите тему",
                "messageMin": "Сообщение должно содержать не менее 10 символов",
                "aboutUs": "О нас"
            },
            "cart": {
                "addToCart": "Добавить в корзину",
                "select": "Выбрать",
                "remove": "Удалить",
            },
            "customerSupport": {
                "customerService": "Обслуживание клиентов",
                "sendMessageAndGetNotified": "Отправьте нам сообщение, и аукционист свяжется с вами как можно скорее",
                "callUs": "Позвоните нам: "
            },
            "roomInfo": {
                "info": "Описание номера",
                "viewAllThePhotos": "Просмотреть все фотографии",
                "roomSize": "Размер номера (кв. м)",
                "peopleInTheRoom": "Люди в номере",
                "doubleBed": "Двуспальная кровать"
            },
            "conceptsList": {
                "conceptsListTitle": "Заголовок списка концепций",
                "includesActivities": "Подарочные аттракционы",
                "includesActivity": "Включает подарочный аттракцион",
                "includeInPackage": "Включено в пакет",
                "transfer": "Трансфер",
                "includesTransfer": "Включает трансфер",
                "transferContent": "Трансферы HOS по цене пакета",
                "baseBoard": "Основной план",
                "autoApprove": "Автоматическое одобрение",
                "airways": "Авиалинии",
                "flightFrom": "Рейс из",
                "flightBack": "Обратный рейс",
                "nights": "Ночей",
                "numberOf": "Количество",
                "toOrder": "Заказать",
                "noPackagesFound": "Пакет не найден",
                "moreDeals": "Больше предложений",
                "pricePerPerson": "Цена за человека"
            },
            "wallet":{
                future: "Нереализованные доходы",
                creditCard:"Кредитная карта",
                cancel: "Отмена",
                forConfirmationRedemption: "Вы уверены, что хотите обменять алмазы?",
                TotalDiamondsYouWillReceive: "Общее количество алмазов, которое вы получите",
                max: "Максимум",
                currentOrderTotal: "Общая сумма текущего заказа",
                MaximumRedeemable: "Максимальная сумма для обмена:",
                UseMax: "Использовать максимум",
                Apply: "Применить",
                Applying: "Применение...",
                RedeemDiamonds: "Обменять алмазы",
                RemainingDiamonds: "Оставшиеся алмазы",
                DiscountedValue: "Стоимость со скидкой",
                RedeemedAmount: "Обмененная сумма",
                Redeemed: "Обменяно",
                totalValue: "Общая стоимость",
                diamondsRate: "1 алмаз = 1 шекель",
                availableDiamonds: "Доступные алмазы",
                diamondBalance: "Баланс алмазов",
                discount: "скидка",
                Subtotal: "Промежуточный итог",
                paymentDetails: "Детали оплаты",
                totalPayment: "Общая сумма к оплате:",
                "wallet": "Кошелек",
                "walletTransactions": "Транзакции кошелька",
                "walletBalance": "Баланс кошелька",
                "diamonds": "алмазы",
                "diamondsAreAvailableAtYourDisposal": "алмазы доступны в вашем распоряжении",
                "paymentWithDiamonds": "Оплата алмазами",
                "returnToOrderManagement": "Вернуться к управлению заказами",
                "reserve": "Резерв",
                "finalize": "Завершить",
                "release": "Освободить",
                "partialRealization": "Частичная реализация",
                "fullRealization": "Полная реализация",
                "selectNumberOfDiamondsForPartialUse": "Выберите количество алмазов для частичного использования",
                "useAllTheDiamondsIHave": "Использовать все алмазы, которые у меня есть",
                "save": "сохранить",
                "confirm": "подтвердить",
                "forConfirmation": "для подтверждения",
                "totalAgentFee": "Общая комиссия агента",

                "dynamicLabels": {
                    'availableDiamondsForPayment': `У вас есть #{amount} алмазов, доступных для оплаты, стоимостью #{price}`,
                    'XOfDiamondsWorthY': `#{amount} алмазов, стоимостью #{price}`,
                    'totalDiamondsYouHaveAccumulatedOverTheLast12MonthsAsOfToday': `Общее количество алмазов, которые вы накопили за последние 12 месяцев на сегодняшний день`,
                  },
            },
            "viewFlight": {
                "sameRates": "Одинаковые тарифы",
                "pleaseSelectDestinationAirport": "Пожалуйста, выберите аэропорт прибытия",
                "noNearbyAirportFound": "Не найден близкий аэропорт. Пожалуйста, найдите аэропорт и убедитесь, что он находится рядом с отелем",
                "chooseAirportYouWantToArrive": "Выберите аэропорт прибытия",
                "chooseAirportYouWantToArriveDescription": "Пожалуйста, выберите аэропорт, ближайший к отелю",
                "updateAirport": "Обновить аэропорт",
                "noFlightsForSelectedDatesLocationPassengers": "Нет доступных рейсов для выбранных дат/места/пассажиров",
                "flightFrom": "Рейс из",
                "flightChange": "Изменение рейса",
                "totalChange": "Полное изменение",
                "noFlightsAvailableForSelectedDates": "Нет доступных рейсов на выбранные даты, пожалуйста, выберите другие даты",
                "show_tickets_with_different_fare_combinations": "Показать билеты с разными тарифными комбинациями",
                "ticketFare": "Тариф",
                "ticketInfo": "Информация о билете",
                "termsAndConditions": "Условия и положения",
                "ifTicketIncludeSeat": "Если билет включает место - клиенту нужно выбрать его на сайте авиакомпании",
                "inCaseOfChange": "В случае изменения - клиенту нужно будет доплатить, если новый билет дороже, а также есть дополнительная плата за обслуживание согласно условиям сайта",
                "inCaseOfCancellation": "В случае отмены - будет взиматься дополнительная плата за обслуживание согласно условиям сайта",
                "error4305Title": "Упс, рейс полностью забронирован",
                "error4305Content": "Извините, но похоже, что места на это предложение распроданы, и мы не можем продолжить покупку. Вы будете перенаправлены на главную страницу.",
                "TC": "Условия",
                "flights": "Рейсы",
                "title": "Выбранный рейс, проверьте детали и перейдите к оплате",
                "addBaggage": "Добавить багаж",
                "closeAddBaggage": "Скрыть опции",
                "addTrolly": "Добавить тележку",
                "somethingWetWrong": "Что-то пошло не так",
                "suitcasePrice": "Цена чемодана",
                "trollyPrice": "Цена тележки",
                "totalPerPassenger": "Итого за пассажира",
                "updatePassengers": "Обновить количество пассажиров",
                "search": "Поиск",
                "seating": "Места",
                "cancelation": "Отмена билета",
                "meal": "Питание",
                "trolly": "Тележка",
                "suitcase": "Чемодан",
                "changeFlight": "Изменить билет",
                "extension": "Продление",
                "totalToBePaid": "К оплате",
                "choose": "Выбрать",
                "checkAmenities": "Проверить удобства",
                "description": "Описание",
                "amenityType": "Тип удобства",
                "flightFromAmenities": "Удобства на вылете",
                "flightBackAmenities": "Удобства на обратном рейсе",
                "BAGGAGE": "Багаж",
                "2 CHECKED BAGS UP TO 32KG EACH": "2 зарегистрированных багажа до 32 кг каждый",
                "2 CABIN BAGS UP TO 8KG": "2 ручные клади до 8 кг",
                "BRANDED_FARES": "Фирменные тарифы",
                "STANDARD SEAT RESERVATION": "Стандартное бронирование места",
                "MILEAGE_ACCRUAL": "Начисление миль",
                "MEAL": "Питание",
                "SNACK": "Перекус",
                "COMPLIMENTARY FOOD AND BEV": "Бесплатное питание и напитки",
                "ENTERTAINMENT": "Развлечения",
                "MAGAZINES / NEWSPAPER": "Журналы / Газеты",
                "LOUNGE": "Зал ожидания",
                "LOUNGE ACCESS": "Доступ в зал ожидания",
                "TRAVEL_SERVICES": "Туристические услуги",
                "PRIORITY BAGGAGE": "Приоритетный багаж",
                "PRIORITY CHECK IN": "Приоритетная регистрация",
                "PRIORITY SECURITY": "Приоритетная безопасность",
                "PRIORITY BOARDING": "Приоритетная посадка",
                "IN FLIGHT ENTERTAINMENT": "Развлечения в полете",
                "PRE_RESERVED_SEAT": "Предварительно забронированное место",
                "PRIVACY SEAT BUSINESS CLASS": "Приватное место бизнес-класса",
                "CHANGE BEFORE DEPARTURE": "Изменение до вылета",
                "CHANGE AFTER DEPARTURE": "Изменение после вылета",
                "REFUND BEFORE DEPARTURE": "Возврат до вылета",
                "REFUND AFTER DEPARTURE": "Возврат после вылета",
                "allFares": "Все тарифы",
                "fareChangedSuccessfully": "Тариф успешно изменен",
                "openFares": "Открытые тарифы",
                "selectedFare": "Выбранный тариф",
                "fullInfo": "Полная информация",
                "MILEAGE ACCRUAL": "Начисление миль"
            },
            "room": {
                "roomSize": "Размер номера",
                "bedType": "Тип кровати",
                "breakfastIncluded": "Завтрак включен",
                "noAvailabilityOnSelectedDates": "Нет доступности для этой комнаты на выбранные даты"
            },
            "promotion": {
                "modelNotFound": "Страница не найдена",
                "failToLoad": "Не удалось загрузить страницу!"
            },
            "searchDatePicker": {
                "showingAllResultsWithin": "Показать все результаты в радиусе",
                'PARTICIPANTS': 'Участники',
                'CITY': 'Город',
                'COUNTRY': 'Страна',
                'EVENT_TYPE': 'Тип события',
                'TOURNAMENTS': 'Турниры',
                'VENUES': 'Места проведения',
                "events":"События",
                "sportsAndEvents":"Спорт и события",
                checking: "Проверка",
                providers: "поставщиков",
                keepScanning: "Продолжайте сканировать",
                validatePricesInRealTime: "Проверьте цены в реальном времени",
                foundSoFar: "Найдено до сих пор",
                return: "Возврат",
                calendar: "Календарь",
                cubes: "Кубики",
                requiredFields: "Пожалуйста, заполните все обязательные поля: пункт назначения, пункт отправления и даты для отображения результатов.",
                otherDeparture: "другое отправление",
                departure: "Отправление",
                "mapView": "Просмотр карты",
                "freeCancellationTooltipText": "Бесплатная отмена действует только для номеров в отеле",
                "dynamicPackages": "Динамические пакеты",
                "includeEvents": "Включить события",
                "includeFullPackage": "Включить полный пакет",
                "searchHotelsByNameTitle": "Поиск по названию отеля для выбранного направления",
                "choose_packages_according_to": "Выберите пакеты в соответствии с",
                "package_hotel_flight": "Пакет (Отель + Рейс)",
                "package_hotel_flight_events": "Пакет (Отель + Рейс + События)",
                "hotel_plus_flight": "Отель + Рейс",
                "hotel_plus_flight_events": "Отель + Рейс + События",
                "tech_stops": "технические остановки",
                "freePlanFlightSearchFooterText": "Бесплатный план позволяет искать только чартерные рейсы! Если вы хотите GDS рейсы",
                "clickHere": "Нажмите здесь",
                "approveSelection": "Подтвердить выбор",
                "room": "Комната",
                "addRoom": "Добавить комнату",
                "removeRoom": "Удалить комнату",
                "needAnotherRoomAddToCart": "Нужен ещё номер? Просто добавьте в корзину.",
                "indirectFlight": "Рейс с пересадками",
                "directFlightLabel": "Прямой рейс",
                "city": "Город",
                "hotel": "Отель",
                "searchForDestination": "Поиск по направлениям",
                "searchByDestinationAndHotel": "Поиск по направлениям и отелям",
                "searchHotelOrDestination": "Поиск отеля или направления",
                "date": "Дата",
                "noResultsForThisDate": "Пакеты не найдены на эту дату",
                "searchDestination": "Поиск направления",
                "pleaseSelectDestination": "Пожалуйста, выберите направление",
                "airlineInformation": "Информация об авиакомпании",
                "airlineCode": "Код",
                "title": "Забронируйте свой идеальный отпуск",
                "hotelOnly": "Поиск отпуска по датам",
                "hotelWithFlight": "Поиск отпуска с рейсом",
                "oneWay": "В одну сторону",
                "roundTrip": "Туда и обратно",
                "selectDate": "Выбор дат",
                "startDate": "Дата начала",
                "endDate": "Дата окончания",
                "flights": "Поиск рейсов",
                "packages": "Пакеты отдыха",
                "hotels": "Отели за границей",
                "israelPackage": "Отдых в Израиле",
                "specialPackage": "Специальные пакеты",
                "passengers": "Пассажиры",
                "adults": "Взрослые",
                "adult": "Взрослый",
                "child": "Ребенок",
                "children": "Дети",
                "infant": "Младенец",
                "infants": "Младенцы",
                "infantsWarningMessage": "Младенец должен быть младше двух лет на момент вылета и возвращения",
                "select": "Выбрать",
                "noResults": "Нет результатов",
                "regularPrice": "Обычная цена",
                "from": "От",
                "purchase": "Купить",
                "selectNewFlight": "Выбрать новый рейс",
                "search": "Поиск",
                "rooms": "Номера",
                "composition": "Состав",
                "chooseComposition": "Выбрать состав",
                "numberOfGuests": "Количество гостей",
                "checkOut": "оформления заказа",
                "checkIn": "Заезд",
                "whatVacation": "Какой вид отдыха",
                "youWant": "вы хотите",
                "vacationFriendsWith": "Отдых с друзьями",
                "familyVacation": "Семейный отдых",
                "romanticVacation": "Романтический отдых",
                "notAvailable": "Недоступно",
                "roomAvailableDuringTheWeek": "Доступность номера в течение недели",
                "followingDates": "Следующие даты",
                "vacation": "Отдых",
                "abroad": "За границей",
                "inIsrael": "В стране",
                "destination": "Все направления",
                "chooseDestination": "Выберите направления",
                "findDreamVacation": "Найдите свой идеальный отпуск одним кликом.",
                "searchResTitle": "Выберите подходящий пакет для вас",
                "directFlight": "Прямой рейс",
                "stops": "остановки",
                "checkHotel": "Проверить отель",
                "noRating": "Нет рейтинга",
                "toOrder": "Заказать",
                "selectAgain": "Выбрать снова",
                "selectFlight": "Выбрать рейс",
                "reselectFlight": "Выбрать рейсы снова",
                "flightCanBeReSelectedNextPage": "Рейс можно выбрать снова на следующей странице",
                "flightSelectedSuccessfully": "Рейс успешно выбран",
                "dynamicFlight": "Динамический рейс",
                "bundle": "Скомбинированный рейс",
                "freeCancelation": "Бесплатная отмена",
                "partially_operated_by_airlines": "Частично обслуживается авиакомпаниями",
                "connect_in_airport": "Пересадка в аэропорту",
                "arrives": "Прибытие",
                "journey_duration": "Продолжительность поездки",
                "short_wait": "Короткое ожидание",
                "long_wait": "Долгое ожидание",
                "flight_number": "Номер рейса",
                "stop_1": "Одна остановка",
                "activeFlight": "Активный рейс",
                "flightSearch": "Поиск рейса",
                "nights": "Ночей",
                "until": "До даты",
                "untilYouSearchForFlightDate": "До даты поиска рейса",
                "destinationFrom": "Отправление",
                "packageSearch": "Поиск пакета",
                "destinationTo": "Прибытие",
                "selectDestination": "Направление",
                "trollyIsIncluded": "Тележка включена",
                "trollyIsNotIncluded": "Тележка не включена",
                "suitcaseIsIncluded": "Чемодан включен",
                "suitcaseIsNotIncluded": "Чемодан не включен",
                "operated_by_airlines": "Обслуживается авиакомпанией"
            },
            "specialDeal": {
                "closeTheDeal": "Заключить сделку ›",
                "endsIn": "Заканчивается через",
                "specialDealForTheWeekend": "Специальное предложение на выходные",
                "from": "С даты",
                "until": "До даты"
            },
            "footer": {
                "backToTop": "Вернуться наверх",
                "allRightsReserved": "© Все права защищены. Запрещено копирование контента с сайта без разрешения.",
                "developBy": "Разработано SKY 360 Tech.",
                "thePurchaseOnTheWebsiteIsSecure": "Покупка на сайте безопасна.",
                "talkToUs": "Как с нами связаться?",
                "address": "Адрес",
                "phoneAndWhatsapp": "Телефон или WhatsApp",
                "phone": "Телефон",
                "whatsapp": "WhatsApp"
            },
            "sportsAndEvents": {
                "atLeastOneTicketMustBeSelected": "Необходимо выбрать хотя бы один билет",
                "dateNotFinal": "Дата не окончательная",
                "timeNotFinal": "Время не окончательное",
                "dateAndTimeNotFinal": "Дата и время не окончательные",
                "dateIsSubjectToChange": "Дата может быть изменена",
                "timeIsSubjectToChange": "Время может быть изменено",
                "dateAndTimeAreSubjectToChange": "Дата и время могут быть изменены",
                "onlyAFewTicketsLeft": "Осталось только несколько билетов",
                "pricePerTicket": "Цена за билет",
                "totalPrice": "Итоговая цена",
                "cannotChangeSeatingFromThisPage": "Вы не можете изменить рассадку с этой страницы",
                "reselectSeating": "Перераспределить места",
                "sportsAndEvents": "Спорт и события",
                "noTitle": "Событие",
                "comingSoon": "Скоро!",
                "noTicketsAvailable": "Билеты недоступны",
                "selectTickets": "Выбрать билеты",
                "notifyMe": "Уведомить меня",
                "notifyMeDescription": "Введите свой email, чтобы получить уведомление, когда билеты станут доступны",
                "notifyMeEmailPlaceholder": "Введите свой email адрес",
                "notifyMeSubmit": "Уведомить меня",
                "notifyMeSuccess": "Вы получите уведомление, когда билеты станут доступны",
                "notifyMeError": "Не удалось отправить уведомление. Пожалуйста, попробуйте еще раз.",
                "notifyMeEmailRequired": "Пожалуйста, введите свой email адрес",
                "notifyMeEmailInvalid": "Пожалуйста, введите действительный email адрес",
                "tournament": "Турнир",
                "participants": "Участники",
                "eventType": "Тип события",
                "vipPackage": "VIP пакет",
                "hold24Hours": "Удержание 24 часа",
                "instantConfirmation": "Мгновенное подтверждение",
                "offlineStock": "Офлайн-наличие",
                "rating": "Рейтинг",
                "location": "Местоположение",
                "dateTimeSeparator": " в ",
                "viewOnMap": "Показать на карте",
                "selectQuantity": "Выберите количество",
                "avenue": "Проспект",
                "venue": "Место проведения",
                "city": "Город",
                "country": "Страна",
                "state": "Штат",
                "zip": "Почтовый индекс",
                "latitude": "Широта",
                "longitude": "Долгота",
                "whereWillISit": "Где я буду сидеть?",
                "seatingArrangements": "Схема рассадки",
                "seatingInPairs": "Рассадка парами",
                "seatingInPairsDescription": "Мы стремимся рассадить вас парами (двое вместе), если категория билета не указывает иное.",
                "seatingInPairsNote": "ОБРАТИТЕ ВНИМАНИЕ: на некоторых стадионах (в частности, на \"Камп Ноу\" в Барселоне и \"Сантьяго Бернабеу\" в Мадриде) \"рассадка парами\" включает диагонально или перпендикулярно примыкающие места.",
                "seatingThreeTogether": "Рассадка трех и более человек",
                "seatingThreeTogetherDescription": "Когда вам нужно три или более билетов, мы сделаем все возможное, чтобы рассадить вас вместе; однако мы не можем это гарантировать.",
                "seatingThreeTogetherNote": "Если вам НЕОБХОДИМО сидеть вместе, пожалуйста, свяжитесь с нашей службой поддержки по телефону или электронной почте. В большинстве случаев мы сможем подтвердить конкретный запрос или предложить альтернативное решение.",
                "homeFansOrAwayFans": "Фанаты хозяев или гостей",
                "homeFansDescription": "Все билеты для сектора хозяев, если не указано иное (\"Сектор гостей\").",
                "homeFansBehaviorCode": "В соответствии с правилами поведения организаторов, вам не разрешается болеть за команду гостей или носить цвета команды гостей. Участникам также рекомендуется носить одежду нейтральных цветов, если они не поддерживают команду хозяев. Несоблюдение этих правил может быть истолковано как провокация и может привести к вашему удалению со стадиона.",
                "neutralVenueNote": "Вышеуказанные спецификации не применяются к матчам, которые проводятся на нейтральном стадионе (например, финал Лиги чемпионов, финал Лиги Европы, финал Кубка Англии, финал Кубка лиги или события Чемпионата мира). Если не указано иное, места могут находиться в любом из секторов, поэтому рекомендуется носить одежду нейтральных цветов.",
                "singleTickets": "Одиночные билеты",
                "singleTicketsDescription": "Мы иногда предлагаем билеты, которые специально классифицируются как \"одиночные\".",
                "singleTicketsNote": "Эти билеты обычно дешевле, но они есть то, что они есть - одиночные. Если вы купите два \"Одиночных\" билета, вы не будете сидеть вместе.",
                "groupSeating": "Групповая рассадка",
                "groupSeatingDescription": "Для 8 билетов или более, пожалуйста, проверьте наличие групповой рассадки и цену с нашей службой поддержки по телефону или электронной почте. Групповая рассадка может стоить меньше или больше, в зависимости от наличия.",
                "groupSeatingNote": "Если выбранная вами категория билетов позволяет это - вы можете оформить заказ без предварительного контакта с нами, но помните, в этом случае мы можем гарантировать только рассадку парами.",
                "pleaseNote": "Обратите внимание",
                "pleaseNoteDescription": "Информация выше о схеме рассадки является общей и в целом может не соответствовать точному описанию выбранного вами билета. Когда доступно, мы представляем соответствующую схему рассадки или карту места проведения.",
                "pleaseNoteConsult": "Пожалуйста, ознакомьтесь с ней при просмотре категорий билетов на это событие.",
                "haveMoreQuestions": "Есть еще вопросы?",
                "contactUsForInfo": "Для получения дополнительной информации, пожалуйста, свяжитесь с нами",
                "eventLoadError": "Не удалось загрузить данные о событии",
                "quantity": "Количество",
                "deliveryMethod": "Способ доставки",
                "selectDeliveryMethod": "Выберите доставку",
                "ticketsAvailable": "билетов доступно",
                "available": "Доступно",
                "quantityCannotBeZero": "Количество не может быть 0",
                "deliveryMethodNotFound": "Способ доставки не найден",
            },

            "newsletter": {
                "title": "Подпишитесь на нашу рассылку",
                "subtitle": "Получайте эксклюзивные предложения и вдохновение для путешествий",
                "placeholder": "Введите ваш email",
                "subscribe": "Подписаться",
                "pleaseEnterEmail": "Пожалуйста, введите ваш email",
                "somethingWentWrong": "Что-то пошло не так. Попробуйте ещё раз."
            },
            "packages": {
                "tour": "Тур",

                "availableSeats": "Доступные места",
                "from": "С даты",
                "until": "До даты",
                "breakfastIncluded": "Завтрак включен",
                "includesMassageAndSpa": "Включает массаж и спа!",
                "lastRoom": "Последний номер!",
                "includesTransfers": "Включает трансферы",
                "includesActivities": "Включает аттракционы",
                "nights": "Ночей",
                "withoutBaggage": "Без багажа",
                "directFlight": "Прямой рейс",
                "oneStop": "Одна остановка",
                "numOfStops": "Остановок",
                "flightDetails": "Детали рейса",
                "flightFrom": " из -> в",
                "flightBack": " из -> в",
                "hours": "Часы",
                "flightNumber": "Номер рейса",
                "airLine": "Авиалиния",
                "suitcaseWeight": "вескг Включенный багаж",
                "trollyWeight": "вескг Включена тележка",
                "includedActivitiesTitle": "Аттракционы и туры в пакете",
                "checkAllPictures": "Просмотреть все фотографии",
                "affiliateWith": "В сотрудничестве с",
                "addButtonDisabledTooltip": "Заказ ограничен количеством номеров - нельзя добавить еще один номер. Чтобы изменить номер, удалите номер из корзины",
                "holidaySchedule": "График отпуска",
                "passengers": "Пассажиры",
                "isRoundTrip": "Цена багажа для кругового путешествия *",
                "includesFlights": "Включает рейсы",
                "includesEventTicket": "Включает билет на мероприятие",
                "returnFlight": "Обратный рейс",
                "outboundFlight": "Исходящий рейс",
                "trollyWeight2": "вес кг тележка / сумка",
                "suitcaseWeight2": "вес кг чемодан",
                "included": "Включено",
                "notIncluded": "Не включено",
                "perPax": "За пассажира",
                "addSuitcaseLater": "Можно добавить позже",
                "clickForDetails": "Нажмите здесь для деталей аттракциона",
                "includedInPackage": "Включено в пакет!"
            },
            "roomPricing": {
                "noRoomsAvailableForSelectedDates": "Нет доступных номеров на выбранные даты, пожалуйста, выберите другие даты",
                "noRoomsAvailable": "Нет доступных номеров на выбранные даты и гостей.",
                "for": "для",
                "addPassenger": "Добавить пассажира",
                "pricePerPerson": "Цена за человека",
                "pricePerRoom": "Цена за номер",
                "priceForAllRooms": "Цена за все номера",
                "payOnSpot": "Оплата на месте",
                "resort_fee": "Курортный сбор",
                "occupancy_tax": "Налог на проживание",
                "totalPrice": "Общая цена",
                "pricePerInfant": "Цена за младенца",
                "composition": "Состав",
                "adultsInTheRoom": "Взрослые",
                "children": "Дети",
                "adults": "Взрослые",
                "single": "Один взрослый",
                "child": "Ребенок",
                "selectInfantCount": "Выберите из списка",
                "infant": "Младенец",
                "1infant": "Один младенец",
                "2infants": "2 младенца",
                "infants": "Младенцы",
                "noInfants": "Без младенцев",
                "all_include": "Все включено",
                "breakfast": "Завтрак",
                "activities": "Выберите тур",
                "half_board": "Полупансион",
                "half_board_kosher": "Кошерный полупансион",
                "full_board": "Полный пансион",
                "sleep_only": "Только номер",
                "breakfast_kidush": "Утренняя и вечерняя трапеза в пятницу",
                "addToCard": "Добавить в заказ",
                "inPackageDates": "В пакетные даты",
                "chooseRoom": "Выберите состав номера",
                "nights": "Ночей",
                "boardType": "Тип питания",
                "filters": "Фильтры",
                "freeCancellation": "Бесплатная отмена",
                "roomInfo": "Информация о номере",
                "noAvailableRooms": "Нет доступных номеров на выбранные даты",
                "noAvailableRoomsForDates": "Нет доступных номеров на выбранные даты",
                "addInfant": "Добавить младенца",
                "roomFacilities": "Удобства в номере",
                "show_images": "Показать изображения",
                "autoApprove": "Автоматическое подтверждение",
                "includedInPrice": "Включено в стоимость",
                "until": "До",
                "no": "Нет",
                "vat": "НДС",
                "is": "Есть",
                "not": "Нет",
                "city_tax": "Городской налог",
                "cancellation_policy": "Политика отмены",
                "your_local_time": "*Ваше местное время",
                "additional_price_info": "Дополнительная информация о цене",
                "policy": {
                    "freeCancallationUntil": "Бесплатная отмена по этой ставке до",
                    "freeCancallationUntil2": "Бесплатная отмена до",
                    "cancallationBeCharged": "С вас будет взиматься",
                    "ifYouCancelBetween": "Если вы отмените с",
                    "ifYouCancelModifiedBetween": "Если вы отменили или изменили после",
                    "cancelFullPrice": "будет взиматься полная стоимость бронирования",
                    "till": "до",
                    "rateNonRefundable": "Ставка не подлежит возврату при отмене"
                }
            },
            "boards": {
                "RO": "Только номер",
                "BB": "Завтрак",
                "HB": "Полупансион",
                "FB": "Полный пансион",
                "AI": "Все включено",
                "UI": "Ультра делюкс все включено",
                "BF": "Буфетный завтрак",
                "KB": "Холодный буфетный завтрак",
                "KBB": "Kosher Breakfast",
                "CB": "Континентальный завтрак",
                "AB": "Американский завтрак",
                "DR": "Ужин и номер",
                "EB": "Английский завтрак",
                "FT": "Полный пансион + процедуры",
                "F+": "Полный пансион плюс",
                "GA": "Праздничный ужин",
                "H6": "Полупансион + только 6 процедур",
                "HT": "Полупансион + процедуры",
                "IB": "Израильский завтрак",
                "KO": "Кошер",
                "KS": "Кошерный завтрак",
                "MI": "Максимум все включено",
                "RB": "Номер и завтрак",
                "NN": "См. маршрут",
                "SI": "Мягкое все включено",
                "UL": "Ультра все включено",
                "half_board": "Полупансион",
                "half_board_kosher": "Кошерный полупансион",
                "full_board": "Полный пансион",
                "sleep_only": "Только номер",
                "breakfast_kidush": "Утренняя и вечерняя трапеза в пятницу",
                "breakfast": "Завтрак",
                "breakfast-for-2": "Завтрак для двоих",
                "nomeal": "Только номер"
            },
            "activitiesTranslations": {
                "addToOrder": "Добавить в заказ",
                "passenger": "Пассажиру",
                "showMore": "Показать больше",
                "addAttractionsAndTrips": "Добавить аттракционы и поездки",
                "doYouWantToAddAttractions": "Хотите добавить аттракционы в ваш отпуск?",
                "itsTime": "Пришло время!",
                "pricePerPerson": "Цена за человека"
            },
            "modal": {
                "viewAllImages": "Посмотреть все изображения",
                "galleryTitle": "Фотогалерея",
                "cancelationTerms": "Условия отмены - ",
                "nameOfTheHotel": "Информация об отеле",
                "hotelInfo": "Об отеле",
                "hotelWebsite": "Ссылка на сайт отеля",
                "showMore": "Показать больше",
                "showLess": "Показать меньше"
            },
            "manageBaggage": {
                "manageBaggage": "Управление багажом",
                "and": "И",
                "save": "Сохранить",
                "purchaseIsNotSupported": "покупка не поддерживается",
                "baggageIsForBothFlights": "Вы можете добавить багаж для рейса туда и обратно",
                "suitcase": "Чемодан",
                "trolly": "Тележка",
                "guest": "Гость"
            },
            "shoppingCartTranslations": {
                localInventoryAlert:"Заказ со специальным пакетом, в настоящее время не поддерживается для просмотра — только для оплаты",
                skyInventory:"Инвентарь SKY",
                recommendedHotel:"Рекомендуемый отель",
                recommendedFlight:"Рекомендуемый рейс",
                "dynamicPackageTitleRemark": "Цена включает рейс и отель - каждый продукт имеет свои условия и положения",
                "dynamicPackageTitleRemarkEvents": "Цена включает рейс, отель и событие - каждый продукт имеет свои условия и положения",
                "productIsApproved": "Этот продукт был одобрен",
                "productIsNotApproved": "Этот продукт не был одобрен",
                "waitingToApprove": "Этот продукт находится в обработке",
                "productIsCancelled": "Этот продукт был отменен",
                "orderIsApproved": "Этот заказ был одобрен!",
                "orderIsNotApproved": "Этот заказ не был одобрен!",
                "orderBeingProcessed": "Этот заказ обрабатывается",
                "orderIsCancelled": "Этот заказ был отменен!",

                "attractionPriceDescription": "Цена на аттракцион зависит от даты, выбора опции и количества билетов",
                "selectedDate": "Выбранная дата",
                "selectADate": "Выберите дату",
                "availableDatesBetween": "Доступные даты между",
                "Options": "Опции",
                "Text": "Текст",
                "Ticket type": "Тип билета",
                "Start Time": "Время начала",
                'Guide language': "Язык руководства",
                "Pick Up Location": "Место отправления",
                "Custom Pick Up Location": "Пользовательское место отправления",
                "Drop Off Location": "Место прибытия",
                "Custom Drop Off Location": "Пользовательское место прибытия",

                "manageBaggage": "Управление багажом",
                "youCanAddGuestsOnlyUpToTheAvailableSeats": "Вы можете добавить гостей только до доступного количества мест",
                "paxExceedsAuthorizedSeats": "Количество пассажиров превышает количество мест, разрешённых по этому тарифу – обратите внимание, что бронирование будет по запросу и цена может измениться",
                "paxExceedsAvailableSeats": "Количество пассажиров превышает доступное количество мест – бронирование будет отправлено на одобрение поставщику, и цена может измениться",
                "shoppingCartButtonTooltip": "Выберите состав и добавьте в заказ",
                "totalPrice": "Общая сумма",
                "proceedToPayment": "Перейти к оплате",
                "placeOrder": "Перейти к регистрации",
                "NoHotelWasChosenForTheVacation": "Отель для отпуска не был выбран",
                "betweenDates": "Между датами",
                "packageInformation": "Детали пакета",
                "rooms": "Детали номера",
                "transfers": "Трансферы",
                "round_trip_transfers": "Трансферы/шаттлы отель – туда и обратно",
                "reg_transfers": "Трансферы/шаттлы в отель и обратно",
                "shuttle_transfers": "Шаттлы от границы до отеля и обратно",
                "flights": "Рейсы",
                "activities": "Аттракционы",
                "shoppingCart": "Корзина",
                "package": "Ночи в отеле",
                "nights": "Ночей",
                "inHotel": "В отеле",
                "apply": "Подтвердить",
                "promoCode": "Промокод",
                "yourShoppingCart": "Ваша корзина",
                "isEmpty": "Еще пусто...",
                "myVacation": "Мой отпуск",
                "showAll": "Показать все »",
                "beforeDiscount": "Общая сумма до скидки -",
                "agentCommission": "Комиссия агента -",
                "agentCommissionNet": "Комиссия агента (чистая сумма) -",
                "discountFromCode": "Скидка по коду -",
                "affiliateWith": "В сотрудничестве с -",
                "tpId": "ID заказа -",
                "chargeTypeFullCC": "Полная оплата - включая комиссию",
                "chargeTypeNetCC": "Оплата подписки по чистой цене",
                "chargeTypeCash": "Наличная транзакция",
                "agentCommissionPrec": "Процент комиссии агента",
                "priceOff": "Скидка",
                "percentageOff": "Процент скидки",
                "selectedItems": "Выбранные позиции",
                "viewProduct": "Посмотреть продукт",
                "infantAdditionalPrice": "Дополнительная цена за младенца",
                "netPriceWarning": "Чистая цена, добавьте прибыль!",
                "copyOrderLink": "Скопировать ссылку",
                "createOrder": "Сохранить предложение",
                "createOrderError": "Не удалось сохранить предложение, попробуйте снова",
                "updateCommission": "Сохранить",
                "commissionNotSaved": "Пожалуйста, нажмите, чтобы сохранить!",
                "clearCart": "Нажмите, чтобы очистить корзину",
                "assignCustomer": "Назначить клиента",
                "firstName": "Имя",
                "lastName": "Фамилия",
                "phone": "Телефон",
                "comment": "Комментарий",
                "email": "Электронная почта",
                "wrongEmailFormat": "Неверный формат электронной почты",
                "saveCustomer": "Сохранить клиента",
                "updateCustomerTitle": "Обновить клиента",
                "createCustomerTitle": "Создать нового клиента",
                "avgPricePerPerson": "Добавить среднюю цену за человека",
                "avgPricePerPersonLine": "Средняя цена за человека",
                "totalPaxLabel": "Кол-во пассажиров",
                "sendByWhatsApp": "Отправить по WhatsApp",
                "copyText": "Копировать текст",
                "copyQuoteTakanonLine": "Убедитесь, что вы прочитали и подтвердили условия до совершения покупки\nСсылка на условия сделки: {domain}/takanon",
                "copyWithOrgDays": "Скопировать предложение с маршрутом по дням",
                "orgItineraryHeader": "Маршрут по дням",
                "orgTourPackageLine": "Организованный тур в {destination}, Название тура: {tourName}, {nights}, {dateStart} - {dateEnd}",
                "packageToDestinationLine": "Отпускной пакет в {destination}",
                "sendBySMS": "Отправить по SMS",
                "findQuoteFor": "Отправить предложение через",
                "linkIsGive": "Предложение в режиме онлайн",
                "dates": "Даты",
                "hotelName": "Название отеля",
                "flightPrice": "Цена рейса",
                "suitcase": "Чемодан",
                "trolly": "Тележка",
                "passengers": "Пассажиры",
                "totalAgentComm": "Общая комиссия агента",
                "agentOptions": "Опции агента",
                "compareDisableForAgent": "Сравнение цен доступно, если в корзине есть 2 предложения",
                "createNewUser": "Создать новое предложение",
                "comparePrice": "Сравнить цены",
                "send": "Отправить предложение",
                "profitPercentageChange": "Изменить прибыль",
                "or": "Или",
                "approval": "Одобрение",
                "profitPerPerson": "Прибыль на человека",
                "grossProfitPercentage": "Процент прибыли",
                "grossProfitPercentageInvalidRange": "Процент прибыли должен быть от 0 до 99",
                "actionNotAllowed": "Действие не разрешено",
                "orderIsAlreadySaved": "Заказ уже сохранен, и дополнительные товары нельзя добавить",
                "clickToClear": "Нажмите, чтобы очистить корзину",
                "roomsByRequestSubjectOfHotelAvailability": "Невозможно добавить тот же тип номера, выберите другой тип номера",
                "roomApprovalIsSubjectToRoomAvailability": "Одобрение номера зависит от наличия номера",
                "unableToAddRoomToSamePackage": "Невозможно добавить номер в тот же пакет",
                "roomsByRequestSubjectOfHotelAvailabilityTitle": "Не удалось добавить номер",
                "youReachedMaxRooms": "Вы достигли максимального количества номеров",
                "eventTicketAlreadyAdded": "Невозможно добавить один и тот же тип билета, пожалуйста, выберите другой тип билета",
                'failedToAddEventTicket':"Не удалось добавить билет события",
                "eventTicketPaxMismatchTitle": "Количество билетов и пассажиров не совпадает",
                "eventTicketPaxMismatch": "Количество выбранных билетов на мероприятие не совпадает с количеством пассажиров (рейс/номер). Обновите количество билетов или выбор номера.",
                "attractionAlreadyAdded": "Невозможно добавить один и тот же тип аттракциона, пожалуйста, выберите другой тип",
                "failedToAddAttraction": "Не удалось добавить аттракцион",
                "noAvailabilityOnThisDates": "Нет доступности на выбранные даты",
                "attractionSearchFailed": "Не удалось найти аттракцион",
                "cannotSearchForThePastDates": "Невозможно выполнить поиск по прошедшим датам",
                "searchOtherForDates": "Нет доступности, пожалуйста, выберите другие доступные даты",
                "adult": "Взрослый",
                "child": "Ребенок",
                "infant": "Младенец",
                "perPerson": "За человека",
                "perVehicle": "За транспортное средство",
                "group": "Группа",
                "family": "Семья",
                "perEquipment": "За оборудование",
                "perBoat": "За лодку",
                "none": "Нет",
            },
            "hotelTypes": {
                "Hotel": "Отель"
            },
            "hotelDetails": {
                "updateDates": "Обновить даты",
                "roomTypesToChooseFrom": "Типы номеров на выбор",
                "metapolicy": "Правила отеля",
                "metaExtraInfo": "Дополнительная информация",
                "not_included": "Не включено",
                "included": "Включено",
                "price": "По цене",
                "address": "Адрес",
                "other": "Адрес",
                "Location": "Местоположение отеля",
                "At the boutique hotel": "Об отеле",
                "Room amenities": "Удобства в номере",
                "parking": "Парковка",
                "pets": "Животные",
                "shuttle": "Трансфер в аэропорт (в одну сторону)",
                "internet": "Интернет-услуги",
                "extra_bed": "Дополнительная кровать",
                "add_fee": "Дополнительная плата",
                "children_meal": "Детское питание",
                "check_in_check_out": "Регистрация заезда и выезда"
            },
            "sideFilters": {
                "sortBy": "Сортировать по",
                "price_asc": "Самая низкая цена",
                "price_desc": "Самая высокая цена",
                "hotel_stars_asc": "Самая низкая оценка отеля",
                "hotel_stars_desc": "Самая высокая оценка отеля",
                "distance": "Расстояние",
                "distance_asc": "Самый близкий расстояние",
                "distance_desc": "Самый дальний расстояние",
                "recommended": "Рекомендуемые",
                "price": "Цена",
                "clearSideFilters": "Очистить фильтры",
                "ts_type": "Типы рейсов",
                "auto_approve": "Мгновенное подтверждение",
                "include_transfer": "Включить трансфер",
                "include_baggage": "Включить багаж",
                "isSpecial": "Специальный",
                "is_special": "Специальный",
                "date_range": "Диапазон дат",
                "from_date_landing_hours": "Время вылета",
                "flight_stop_time": "Время остановки",
                "return_date_landing_hours": "Время обратного рейса",
                "include_trolly": "Включить тележку",
                "auto_approve_checked": "Показаны результаты с мгновенным подтверждением",
                "from_date_hours": "Время вылета",
                "return_date_hours": "Время обратного рейса",
                "airline": "Авиалиния",
                "2": "Чартерные рейсы",
                "3": "Регулярные рейсы",
                "nonStop": "Прямой рейс",
                "stop": "Одна остановка",
                "stops_plural": "Остановки",
                "hotel_type": "Типы размещения",
                "stops": "Количество остановок",
                "freeCancellation": "Бесплатная отмена?",
                "freeCancellationLabels": {
                    "1": "Только с бесплатной отменой",
                    "0": "Без бесплатной отмены"
                },

                "feature": "Особенность",

                "event_type": "Типы событий",
                "avenue": "Проспект",
                "event_date": "Дата события",
            },
            "package_feature": {
                "SPECIAL PACKAGE": "Специальный пакет",
                "ALL PACKAGES": "Все пакеты",
                "KOSHER": "Кошерный",
                "TOUR": "Тур",
                "SKI": "Лыжи",
                "EVENT": "Событие",
                "SPORT": "Спорт",
                "SPA": "Спа",
                "YOUNG VACATION": "Молодежный отдых",
                "FLT+HTL+CAR": "Полёт+Отель+Машина"
            },
            "hotelAmenities": {},
            "general": {
                "km": "км",
                "showingAllResultsWithin": "Показать все результаты в радиусе",
                "kmFromVenue": "км от места",
                "kmFromCityCenter": "км от центра города",
                openBO: "Открыть бэк-офис",
                logOut: "Выйти",
                "toOrder": "Заказать",
                "amount": "Сумма",
                parentOriginal: "Оригинал родителя",
                parentEdited: "Изменено родителем",
                "fetchingMoreResults": "Загрузка дополнительных результатов...",
                "error": "Ошибка",
                "somethingWentWrong": "Что-то пошло не так. Попробуйте ещё раз.",
                "noResultsFound": "События не найдены",
                "tryAdjustingFilters": "Попробуйте изменить фильтры или критерии поиска",
                "refresh": "Обновить",
                "list": "Список",
                "matched": "Совпадает",
                "rates": "Цены",
                "calculatedRates": "Рассчитанные цены",
                "selected": "Выбрано",
                "to": "до",
                "roomOnly": "Только номер",
                "totalPrice": "Общая стоимость",

                "close": "Закрыть",
                "language": "Язык",
                "remark": "Примечание",
                "addService": "Добавить услугу",

                packagesMainTitle: "Пакеты отдыха",
                vacationAtHeader: "Отпуск в",
                daysOfStay: "Дни пребывания",
                lowPrice: "Низкая цена",
                flightUpTo: "Перелет от",
                flightsPromoTitle: "последние рейсы",
                additionalFlights:"Дополнительные рейсы",
                "additionalPackages": "Дополнительные пакеты",
                "packagePlan": "Турпакеты от",
                "immediateApproval": "Мгновенное одобрение",
                "total": "Итого",
                "as_of_today": "по состоянию на сегодня",
                "priceInIls": "({price} ₪)",
                "link_to_the_offer": "Ссылка на предложение",
                "the_quote_has_been_copied_successfully": "Котировка успешно скопирована",
                "base": "Основа",
                "usd": "USD",
                "euro": "ЕВРО",
                "address": "Адрес",
                "type": "Тип",
                "noResults": "Нет результатов",
                "boardBasis": "Тип питания",
                "nights": "Ночей",
                "supplier": "Поставщик",
                "airLine": "Авиалиния",
                "price": "Цена",
                "totalRoomPrice": "Общая стоимость",
                "priceForXRooms": "Цена за X номеров",
                "hotel": "Отель",
                "hotel_stars": "Звезды отеля",
                "minPrice": "Минимальная цена",
                "BB": "Завтрак",
                "HB": "Полупансион",
                "cancel": "Отмена",
                "replaceShoppingCart": "Заменить корзину",
                "replace": "Заменить",
                "searchForUser": "Поиск пользователя",
                "acceptCookiesTitle": "Этот веб-сайт использует файлы cookie, чтобы вы получили лучший опыт на нашем сайте.",
                "acceptCookiesBtn": "Принять",
                "includesActivities": "{NUMBER} подарочных аттракционов!",
                "includesActivity": "Включает подарочный аттракцион!",
                "adults": "Взрослые",
                "all_include": "Все включено",
                "breakfast": "Завтрак",
                "half_board": "Полупансион",
                "half_board_kosher": "Кошерный полупансион",
                "full_board": "Полный пансион",
                "sleep_only": "Только размещение",
                "breakfast_kidush": "Завтрак и ужин в пятницу",
                "addToCard": "Добавить в заказ",
                "chooseRoom": "Выберите состав и номер",
                "boardType": "Тип размещения",
                "filters": "Фильтры",
                "rating": "Рейтинг отеля",
                "event": "Мероприятие",
                "children": "Дети",
                "toDate": "До",
                "transfers": "Трансферы",
                "from": "Начиная с",
                "perPerson": "За человека",
                "include": "Включает",
                "noIncludeText": "Пакеты отдыха",
                "flights": "Рейсы",
                "vacationAt": "Отдых в {DEST}",
                "fieldRequired": "Обязательное поле",
                "showAll": "Показать все",
                "showLess": "Показать меньше",
                "flight": "рейс",
                "h": "ч",
                "min": "мин",
                "tickets": "Билеты",
                "deliveryMethod": "Способ доставки",
                "availableSeats": "Доступные места",
                "showGrossPrice": "Показать валовую цену",
                "showNetPrice": "Показать чистую цену",
                "noRating": "Без рейтинга",
                "bundleFlight": "Круговой рейс",
                "oneWayBundleFlight": "Рейс в одну сторону",
                "trollyIsIncluded": "Тележка включена",
                "trollyIsNotIncluded": "Тележка не включена",
                "suitcaseIsIncluded": "Чемодан включен",
                "suitcaseIsNotIncluded": "Чемодан не включен",
                "additionalSuitcases": "Включает X чемоданов",
                "additionalTrolly": "Включает X тележек",
                "returnFlight": "Обратный рейс",
                "outboundFlight": "Исходящий рейс",
                "agentMode": "Режим агента",
                "userMode": "Режим клиента",
                "suitcase": "Чемодан",
                "trolly": "Тележка",
                "packageSearchResult": "Найденные для вас пакеты",
                "day": "День",
                "selectDate": "Выберите даты",
                "search": "Поиск",
                "adult": "Взрослый",
                "child": "Ребенок",
                "infant": "Младенец",
                "infants": "Младенцы",

                "loading": "Загрузка",
                "showingMoreResults": "Показ дополнительных результатов",
                "noMoreResults": "Больше результатов нет",
                "NoResultsMatchedTheFilterValues": "Нет результатов, соответствующих параметрам фильтра",
                "eventTicketsAdded": "Билеты на мероприятие добавлены",
                "addEventTickets": "Добавить билеты на мероприятие",
                "add": "Добавить",
            },
            "subsidizedForm": {
                "title": "Добавить субсидию",
                "employee_id": "Номер сотрудника",
                "person_id": "Идентификационный номер (9 цифр)",
                "validate": "Проверить код сотрудника",
                "alreadyApplied": "Субсидия уже применена",
                "addOneMore": "Добавить еще одну субсидию",
                "addOneMoreId": "Добавить еще одного сотрудника",
                "fieldRequired": "Обязательное поле",
                "priceReducedBy": "Цена снижена на",
                "forEmployee": "Для сотрудника",
                "employeeIs": "Успешно идентифицирован",
                "error4401": "Не удалось идентифицировать, попробуйте еще раз",
                "error4402": "Код идентифицирован, но уже используется",
                "guestIdentifiedId": "Идентифицирован по ID",
                "guestNotIdentified": "Вы должны идентифицироваться перед регистрацией",
                "clickToIdentify": "Нажмите для идентификации"
            },
            "uploadImage": {
                "uploadPassportImage": "Загрузить фото паспорта",
                "somethingWentWrong": "Что-то пошло не так"
            },
            "flightButton": {
                "no_availability_for_this_flight_price": "Извините, но больше нет мест по этой цене за перелет",
                "cardConditions": "Условия карты",
                "flightTotalPrice": "Цена на рейс в одну сторону",
                "total": "Итого",
                "continueToOrder": "Перейти к заказу",
                "addToCart": "Добавить в корзину",
                "lastPlace": "Последние доступные места",
                "pricePerPassenger": "Цена за пассажира"
            },
            "agentCommission": {
                "supplier": "Поставщик",
                "commission": "Комиссия",
                "recommendedFee": "Рекомендуемая плата",
                "transactionDetailsForAgent": "Детали для агента",
                "supplierNotes": "Примечания поставщика",
                "cancellationConditions": "Условия отмены",
                "addToCartToChangeFree": "Добавьте в корзину для изменения комиссии",
                "pricesShownAreNetPrices": "Показаны чистые цены",
                "pricesShownAreGrossPrices": "Показаны валовые цены",
                "packageRemarks": "Замечания по пакету"
            },
            "blog": {
                "home": "Главная",
                "blog": "Блог",
                "categories": "Категории",
                "articles": "Статьи",
                "articlesIn": "статей в",
                "latestTravelStories": "Последние истории о путешествиях",
                "discoverInspiring": "Откройте для себя вдохновляющие направления и советы экспертов",
                "viewAllArticles": "Смотреть все статьи",
                "readMore": "Читать далее",
                "minRead": "мин чтения",
                "addBookmark": "Добавить в закладки",
                "removeBookmark": "Удалить из закладок",
                "shareThisArticle": "Поделиться статьей",
                "shareThisCategory": "Поделиться категорией",
                "shareWithFriendsAndFamily": "Поделитесь любимыми статьями с друзьями и семьей",
                "share": "Поделиться",
                "shareOnFacebook": "Поделиться в Facebook",
                "shareOnTwitter": "Поделиться в Twitter",
                "shareOnLinkedIn": "Поделиться в LinkedIn",
                "shareOnPinterest": "Поделиться в Pinterest",
                "shareOnInstagram": "Поделиться в Instagram",
                "copyLink": "Копировать ссылку",
                "linkCopied": "Ссылка скопирована!",
                "copied": "Скопировано!",
                "copyFailed": "Не удалось скопировать",
                "followUs": "Подписывайтесь",
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "relatedArticles": "Похожие статьи",
                "noPostsFound": "Статьи не найдены",
                "postNotFound": "Статья не найдена",
                "showing": "Показано",
                "sortBy": "Сортировать:",
                "newestFirst": "Сначала новые",
                "alphabetical": "А-Я",
                "gridView": "Сетка",
                "listView": "Список",
                "exploreMoreCategories": "Другие категории",
                "travelInspiration": "Вдохновение для путешествий",
                "getWeeklyGuides": "Откройте скрытые жемчужины и эксклюзивные советы путешественников для таких любителей приключений, как вы",
                "bookYourFlight": "Забронировать рейс",
                "facebookShare": "Facebook",
                "twitterShare": "Twitter",
                "instagramShare": "Instagram",
                "linkedinShare": "LinkedIn",
                "whatsappShare": "WhatsApp",
                "pinterestShare": "Pinterest",
                "shareArticle": "Поделиться статьей",
                "shareCategory": "Поделиться категорией",
            },
            "onboarding": {
                "openOnboarding": "Руководство",
                "welcomeTitle": "Добро пожаловать в Sky360",
                "subtitle": "Получите максимум от нашей платформы с этим кратким туром. Выполните каждый шаг, чтобы изучить всё, что мы предлагаем.",
                "progressTitle": "Ваш прогресс",
                "progressLabel": "Выполнено",
                "continueOnboarding": "Продолжить",
                "yourPath": "Шаги обучения",
                "pathSubtitle": "Следуйте этим шагам, чтобы изучить все наши продукты.",
                "markAsDone": "Отметить как выполненное",
                "upNext": "СЛЕДУЮЩЕЕ",
                "continue": "Продолжить",
                "outcomesTitle": "ЧТО ВЫ УЗНАЕТЕ",
                "outcome1": "Поиск и бронирование",
                "outcome1Desc": "Найдите пакеты, рейсы, отели и многое другое.",
                "outcome2": "Мероприятия и достопримечательности",
                "outcome2Desc": "Откройте для себя местные впечатления в вашем направлении.",
                "stepCompleted": "Выполнено",
                "stepCompletedBanner": "Шаг выполнен! Вы делаете отличный прогресс.",
                "stepCompletionTitle": "Шаг {num} выполнен!",
                "stepCompletionKicker": "Отличная работа — так держать!",
                "tasksCompleted": "Задания: {done}/{total} выполнено",
                "typeTask": "ВЫПОЛНИТЬ",
                "stepLabel": "ШАГ",
                "nextStepHint": "Следующий: Шаг {num} — {title}",
                "continueUpNext": "Начать",
                "tourFinishBtn": "Готово",
                "tourNextBtn": "Далее",
                "tourPrevBtn": "Назад",
                "tourActionHint": "👆 Нажмите на кнопку выше, чтобы продолжить",
                "typeLearn": "ИЗУЧИТЬ",
                "steps": {
                    "step1": { "title": "Поиск пакетных туров", "description": "Узнайте, как найти и забронировать пакеты с перелётами и отелями." },
                    "step2": { "title": "Поиск рейсов", "description": "Найдите рейсы в одну сторону или туда-обратно, настройте пассажиров и даты." },
                    "step3": { "title": "Поиск отелей", "description": "Просматривайте отели по направлению, датам заезда и числу гостей." },
                    "step4": { "title": "Достопримечательности", "description": "Откройте местные активности в вашем направлении." },
                    "step5": { "title": "Поиск мероприятий", "description": "Просматривайте мероприятия и объединяйте их с перелётом и отелем." },
                    "step6": { "title": "Обзор поисковой системы", "description": "Переключайтесь между всеми типами продуктов в одном месте." },
                    "step7": { "title": "Поиск динамических пакетов", "description": "Создайте индивидуальный тур, выбрав направление или отель и добавив прямой рейс." },
                    "step8": { "title": "Создание бронирования рейса", "description": "Пройдите полный процесс бронирования рейса — от поиска до оплаты." },
                    "step9": { "title": "Обзор панели агента", "description": "Панель агента в верхней части B2C позволяет управлять клиентами, переключать режимы ценообразования, просматривать баланс Diamonds и многое другое." },
                    "step10": { "title": "Создание бронирования пакета", "description": "Пройдите полный процесс бронирования пакета — от поиска до оплаты." },
                    "step11": { "title": "Обзор страницы управления заказом", "description": "Изучите страницу управления заказом — просматривайте детали бронирования, обновляйте данные гостей и переходите к оплате." }
                },
                "tour": {
                    "seModHoverTitle": "Действия с модулем",
                    "seModHoverDesc": "Наведите курсор на любой модуль на странице ниже — появится небольшая панель действий для этого модуля. Наведите на один сейчас, чтобы пройти по каждому действию.",
                    "seModAddTopTitle": "Добавить модуль выше",
                    "seModAddTopDesc": "Вставляет новый модуль прямо над этим. Нажмите, чтобы выбрать тип модуля и поместить его.",
                    "seModReorderTitle": "Изменить порядок модуля",
                    "seModReorderDesc": "Используйте стрелки вверх и вниз, чтобы переместить модуль раньше или позже на странице. Превью переупорядочивается мгновенно.",
                    "seModEditTitle": "Редактировать модуль",
                    "seModEditDesc": "Открывает этот модуль в панели настроек слева, где вы можете изменить его содержимое, макет и оформление.",
                    "seModDeleteTitle": "Удалить модуль",
                    "seModDeleteDesc": "Удаляет этот модуль со страницы. Вы всегда можете добавить его обратно позже через опции добавления модуля.",
                    "seModAddBottomTitle": "Добавить модуль ниже",
                    "seModAddBottomDesc": "Вставляет новый модуль прямо под этим — то же самое, что верхняя кнопка, только для слота снизу.",
                    "packagesDpSwitchTitle": "Динамические пакеты — рейс + отель", "packagesDpSwitchDesc": "Переключитесь в режим динамического пакета — выберите отель, и система объединит его с самым дешёвым доступным рейсом по маршруту, создав конкурентоспособную цену полного пакета на месте.",
                    "packagesFeaturesTitle": "Категории пакетов", "packagesFeaturesDesc": "Выберите тип туристического пакета — организованные туры, спортивные поездки, кошерные туры и другие.",
                    "pkgSpecialTitle": "Специальные пакеты — фиксированная комиссия 10%", "pkgSpecialDesc": "Это категория специальных пакетов — организованные групповые туры, управляемые платформой. Каждый специальный пакет включает фиксированную агентскую комиссию 10%. Идеально для быстрых уверенных продаж — без переговоров о цене.",
                    "pkgOtherCatsTitle": "Другие категории пакетов", "pkgOtherCatsDesc": "Это другие категории пакетов — организованные туры, кошерные путешествия, горнолыжные туры, спа-отдых, спортивные события и другое. Каждая категория автоматически фильтрует доступные пакеты и направления.",
                    "pkgSelectCatTitle": "Попробуйте — выберите категорию", "pkgSelectCatDesc": "Нажмите на любую карточку категории, чтобы отфильтровать пакеты по типу. Список доступных направлений обновится автоматически.",
                    "pkgFilteredDestsTitle": "Отфильтрованные направления", "pkgFilteredDestsDesc": "При выборе категории список направлений автоматически фильтруется, чтобы показать только места, где доступны пакеты этого типа. Выберите направление для продолжения.",
                    "pkgDeselectCatTitle": "Нажмите ещё раз для отмены", "pkgDeselectCatDesc": "Повторный щелчок по активной категории отменит её — список направлений вернётся ко всем доступным пакетам. Попробуйте сейчас.",
                    "pkgDepartureTitle": "Город вылета", "pkgDepartureDesc": "Выберите аэропорт или город, из которого вы будете лететь в рамках пакетного тура.",
                    "packagesDestTitle": "Выберите направление", "packagesDestDesc": "Выберите одно или несколько направлений для вашего пакетного тура.",
                    "packagesGuestsTitle": "Пассажиры", "packagesGuestsDesc": "Выберите количество пассажиров — взрослых, детей и младенцев — для вашего пакетного тура.",
                    "packagesDatesTitle": "Даты поездки", "packagesDatesDesc": "Выберите даты вылета и возвращения для пакета.",
                    "packagesSearchTitle": "Найти пакеты", "packagesSearchDesc": "Нажмите для поиска доступных пакетов.",
                    "flightTripTypeTitle": "Тип поездки", "flightTripTypeDesc": "Переключайтесь между рейсом в одну сторону и туда-обратно.",
                    "flightDirectTitle": "Только прямые рейсы", "flightDirectDesc": "Включите этот переключатель для фильтрации результатов — только прямые рейсы без пересадок.",
                    "flightDepartureTitle": "Город вылета", "flightDepartureDesc": "Выберите аэропорт или город вылета.",
                    "flightArrivalTitle": "Пункт назначения", "flightArrivalDesc": "Выберите аэропорт или город назначения.",
                    "flightPaxTitle": "Пассажиры", "flightPaxDesc": "Задайте число взрослых, детей и младенцев.",
                    "flightDatesTitle": "Даты рейса", "flightDatesDesc": "Выберите дату вылета и возвращения.",
                    "flightSearchTitle": "Найти рейсы", "flightSearchDesc": "Нажмите для поиска доступных рейсов.",
                    "hotelDestTitle": "Направление отеля", "hotelDestDesc": "Найдите город или регион для проживания.",
                    "hotelGuestsTitle": "Номера и гости", "hotelGuestsDesc": "Добавьте столько номеров, сколько нужно, и настройте каждый отдельно — укажите количество взрослых, детей и младенцев для каждого номера. Смешивайте конфигурации под состав любой группы: пары, семьи или любые комбинации.",
                    "hotelDatesTitle": "Заезд и выезд", "hotelDatesDesc": "Выберите даты заезда и выезда.",
                    "hotelSearchTitle": "Найти отели", "hotelSearchDesc": "Нажмите для поиска доступных отелей.",
                    "attrDestTitle": "Город аттракции", "attrDestDesc": "Введите или выберите город достопримечательностей.",
                    "attrDatesTitle": "Даты активности", "attrDatesDesc": "Выберите диапазон дат для мероприятий.",
                    "attrTypeTitle": "Тип аттракции", "attrTypeDesc": "Фильтруйте по категории — музеи, активный отдых, экскурсии и другое.",
                    "attrSearchTitle": "Найти достопримечательности", "attrSearchDesc": "Нажмите для поиска достопримечательностей в выбранном городе.",
                    "eventsPackageTitle": "Включить полный пакет", "eventsPackageDesc": "Объедините мероприятие с перелётом и отелем.",
                    "eventsEventTitle": "Найти мероприятие", "eventsEventDesc": "Введите название мероприятия или просматривайте доступные варианты.",
                    "eventsDatesTitle": "Даты мероприятия", "eventsDatesDesc": "Выберите диапазон дат мероприятия.",
                    "eventsSearchTitle": "Найти мероприятия", "eventsSearchDesc": "Нажмите для поиска мероприятий.",
                    "mainTabsTitle": "Выберите тип поиска", "mainTabsDesc": "Переключайтесь между пакетами, рейсами, отелями, достопримечательностями и мероприятиями.",
                    "mainFormTitle": "Форма поиска", "mainFormDesc": "Заполните данные о путешествии и нажмите «Найти».",
                    "mainPkgTabTitle": "Пакетные туры", "mainPkgTabDesc": "Найдите туристические пакеты «всё включено» с авиабилетами и отелями. Нажмите эту вкладку, чтобы увидеть форму поиска пакетов.",
                    "mainPkgFormTitle": "Форма поиска пакетов", "mainPkgFormDesc": "Укажите город отправления, направление, даты поездки и конфигурацию номеров. Каждое поле помогает найти наиболее подходящие варианты для ваших клиентов.",
                    "mainFltTabTitle": "Авиабилеты", "mainFltTabDesc": "Ищите отдельные рейсы — в одну сторону или туда-обратно. Нажмите эту вкладку, чтобы увидеть форму поиска рейсов.",
                    "mainFltFormTitle": "Форма поиска рейсов", "mainFltFormDesc": "Выберите тип рейса, города отправления и прибытия, даты и количество пассажиров. Включите 'Только прямые рейсы', чтобы исключить стыковки.",
                    "mainHtlTabTitle": "Отели", "mainHtlTabDesc": "Ищите отели по всему миру без пакетного тура. Нажмите эту вкладку, чтобы увидеть форму поиска отелей.",
                    "mainHtlFormTitle": "Форма поиска отелей", "mainHtlFormDesc": "Введите направление, даты заезда и выезда, а также конфигурацию номеров. Добавляйте несколько номеров и настраивайте каждый отдельно под вашу группу.",
                    "mainAttrTabTitle": "Достопримечательности", "mainAttrTabDesc": "Откройте местные достопримечательности, экскурсии и развлечения в любом направлении. Нажмите эту вкладку, чтобы увидеть форму поиска.",
                    "mainAttrFormTitle": "Форма поиска достопримечательностей", "mainAttrFormDesc": "Выберите город, диапазон дат и тип активности для поиска доступных занятий. Отлично подходит для дополнений к любому бронированию.",
                    "mainEvtTabTitle": "Мероприятия", "mainEvtTabDesc": "Бронируйте билеты на концерты, спортивные матчи, фестивали и другие мероприятия — с возможностью полного пакета с рейсом и отелем. Нажмите эту вкладку для формы поиска.",
                    "mainEvtFormTitle": "Форма поиска мероприятий", "mainEvtFormDesc": "Ищите мероприятия по названию или направлению и устанавливайте даты. Включите 'Полный пакет', чтобы объединить мероприятие с рейсом и отелем в одном бронировании.",
                    "dynDpSwitchTitle": "Рейс + отель — динамический пакет", "dynDpSwitchDesc": "Динамические пакеты объединяют выбранный вами отель с самым дешёвым доступным рейсом по маршруту — формируя конкурентоспособную полную цену пакета на месте. Система автоматически фиксирует лучшую цену рейса и объединяет её с результатами по отелям.",
                    "dynDirectTitle": "Прямой рейс", "dynDirectDesc": "При включении результаты ограничиваются только прямыми рейсами. Выключите, чтобы включить рейсы с пересадками.",
                    "dynDepartureTitle": "Город вылета", "dynDepartureDesc": "Выберите аэропорт или город, из которого вы будете лететь в рамках динамического пакета.",
                    "dynDestTitle": "Направление или название отеля", "dynDestDesc": "Ищите по городу назначения, чтобы просмотреть все доступные отели в районе — или введите конкретное название отеля, чтобы перейти прямо к нему. Прямой переход к отелю быстрее, когда у клиента уже есть предпочтение, и помогает создать лучший пакет за секунды.",
                    "dynDatesTitle": "Даты проживания", "dynDatesDesc": "Выберите даты заезда и выезда в отеле.",
                    "dynGuestsTitle": "Номера и гости", "dynGuestsDesc": "Добавьте столько номеров, сколько нужно, и настройте каждый отдельно — укажите количество взрослых, детей и младенцев для каждого номера. Смешивайте конфигурации под состав группы клиента: например, семья с детьми в одном номере и пара в другом.",
                    "dynSearchTitle": "Поиск динамического пакета", "dynSearchDesc": "Нажмите для поиска доступных динамических пакетов по выбранному направлению, датам и гостям.",
                    "fltSearchActionTitle": "Найти рейс", "fltSearchActionDesc": "Заполните данные о путешествии и нажмите Найти для поиска доступных рейсов.",
                    "fltResOnewayDayTitle": "Быстрая навигация по датам", "fltResOnewayDayDesc": "Используйте карточки дней для быстрого перехода к другой дате вылета с обновлёнными ценами.",
                    "fltResOnewayFiltersTitle": "Фильтры результатов", "fltResOnewayFiltersDesc": "Используйте боковые фильтры для сужения результатов по авиакомпании, диапазону цен, числу пересадок и времени рейсов.",
                    "fltResOnewayCardsTitle": "Доступные рейсы", "fltResOnewayCardsDesc": "Просматривайте список доступных рейсов. Каждая карточка показывает авиакомпанию, номер рейса, длительность, пересадки и цену.",
                    "fltResOnewayActionTitle": "Выберите рейс", "fltResOnewayActionDesc": "Нажмите «Выбрать рейс» на любой карточке для перехода на страницу деталей бронирования.",
                    "fltResBundleTabTitle": "Туда-обратно vs Динамический", "fltResBundleTabDesc": "Переключайтесь между «Выберите рейсы самостоятельно» — включая гибкие односторонние сегменты и навигацию по датам — и «Заранее определённые рейсы» — пакеты туда-обратно.",
                    "fltResBundleFiltersTitle": "Фильтры результатов", "fltResBundleFiltersDesc": "Используйте боковые фильтры для сужения результатов по авиакомпании, диапазону цен, числу пересадок и времени рейсов.",
                    "fltResBundleCardsTitle": "Варианты пакетных рейсов", "fltResBundleCardsDesc": "Каждая карточка показывает полный рейс туда-обратно с деталями и общей стоимостью.",
                    "fltResBundleActionTitle": "Перейти к заказу", "fltResBundleActionDesc": "Нажмите «Перейти к заказу» на выбранном рейсе для просмотра деталей и добавления в корзину.",
                    "fltResBundleResumeActionTitle": "Перейти к заказу", "fltResBundleResumeActionDesc": "Выберите пакетный рейс и нажмите «Перейти к заказу» для продолжения.",
                    "fltResDynDayTitle": "Быстрая навигация по датам", "fltResDynDayDesc": "Используйте карточки дат для быстрого перехода к другой дате вылета и просмотра изменений цен.",
                    "fltResDynFiltersTitle": "Фильтры", "fltResDynFiltersDesc": "Сужайте результаты по авиакомпании, пересадкам, ценовому диапазону и времени рейсов.",
                    "fltResDynOutboundTitle": "Рейсы туда", "fltResDynOutboundDesc": "Просмотрите доступные рейсы туда. Каждая карточка показывает авиакомпанию, маршрут, время и цену на пассажира.",
                    "fltResDynOutboundActionTitle": "Выбрать рейс туда", "fltResDynOutboundActionDesc": "Нажмите «Выбрать рейс» на предпочитаемой карточке для подтверждения.",
                    "fltResDynReturnTitle": "Рейсы обратно", "fltResDynReturnDesc": "Теперь выберите обратный рейс. Просмотрите все доступные варианты.",
                    "fltResDynReturnActionTitle": "Выбрать обратный рейс", "fltResDynReturnActionDesc": "Нажмите «Выбрать рейс», чтобы зафиксировать обратный перелёт.",
                    "fltResDynFinalTitle": "Выбранные рейсы", "fltResDynFinalDesc": "Оба рейса выбраны. Ознакомьтесь с итоговой ценой перед продолжением.",
                    "fltResDynFinalActionTitle": "Перейти к заказу", "fltResDynFinalActionDesc": "Нажмите «Перейти к заказу» для просмотра полных деталей бронирования.",
                    "fltViewAgentCommTitle": "Комиссия агента",
                    "fltViewAgentCommDesc": "Ознакомьтесь с предлагаемой комиссией агента для этого рейса перед добавлением в корзину.",
                    "fltViewCardTitle": "Детали рейса", "fltViewCardDesc": "Просмотрите полную информацию о рейсе — авиакомпания, маршрут, время, пересадки и варианты багажа.",
                    "fltViewPriceTitle": "Сводка цены", "fltViewPriceDesc": "Общая стоимость показана на пассажира и суммарно. Агенты могут задать комиссию перед добавлением в корзину.",
                    "fltViewTcTitle": "Правила и условия", "fltViewTcDesc": "Изучите правила тарифа и условия отмены — включая важные ограничения — перед добавлением в корзину.",
                    "fltViewActionTitle": "Добавить в корзину", "fltViewActionDesc": "Нажмите «Добавить в корзину» для бронирования рейса. Откроется корзина для проверки перед оплатой.",
                    "fltCartProductsTitle": "Ваша корзина", "fltCartProductsDesc": "Корзина может содержать несколько товаров любого типа — рейсы, отели, пакеты и многое другое. Вы можете добавить столько позиций, сколько нужно, в один заказ. Проверьте всё добавленное здесь перед тем как продолжить.",
                    "fltCartItemsTitle": "Товары в корзине", "fltCartItemsDesc": "Каждый товар в корзине перечислен здесь — детали рейса, тип номера, даты и разбивка по пассажирам. Убедитесь, что все позиции верны, перед сохранением или продолжением.",
                    "fltCartManageBaggageTitle": "Управление багажом", "fltCartManageBaggageDesc": "Нажмите эту кнопку для управления багажом каждого пассажира — добавьте дополнительный багаж или настройте параметры для рейсов туда и обратно по отдельности.",
                    "fltCartDiamondsTitle": "Бонусные бриллианты", "fltCartDiamondsDesc": "Количество бриллиантов показывает кэшбэк-вознаграждение, которое вы получите за это бронирование.",
                    "fltCartAgentTitle": "Настройки агента", "fltCartAgentDesc": "Как агент, вы полностью контролируете свою комиссию по этому заказу. Задайте процент от общей суммы или фиксированную сумму на человека — вы сами решаете, сколько зарабатывать на каждом бронировании.",
                    "fltCartAgentProfitBtnTitle": "Изменить прибыль", "fltCartAgentProfitBtnDesc": "Нажмите эту кнопку, чтобы открыть настройки прибыли и изменить расчёт комиссии.",
                    "fltCartAgentProfitInputsTitle": "Настройки прибыли", "fltCartAgentProfitInputsDesc": "Введите процент от общей стоимости или фиксированную сумму на человека. Система применяет активный режим.",
                    "fltCartAgentSendBtnTitle": "Отправить предложение", "fltCartAgentSendBtnDesc": "Чтобы получить ссылку на живое предложение: сначала привяжите клиента к заказу, затем нажмите «Сохранить предложение» — это создаёт ссылку. После сохранения нажмите эту кнопку, чтобы открыть панель «Отправить предложение», где можно скопировать живую ссылку, отправить её через WhatsApp или поделиться по email. Живая ссылка даёт клиенту просмотр заказа в реальном времени с актуальными ценами.",
                    "fltCartAssignCustomerTitle": "Привяжите клиента", "fltCartAssignCustomerDesc": "Нажмите кнопку «Привязать клиента», чтобы открыть форму данных клиента и привязать его к этому заказу.",
                    "fltCartAssignModalTitle": "Заполните данные клиента", "fltCartAssignModalDesc": "Заполните обязательные поля — имя, телефон, email — и нажмите «Сохранить клиента», чтобы привязать его к этому заказу. Окно закроется автоматически после сохранения.",
                    "fltCartCustomerTitle": "Привязанный клиент", "fltCartCustomerDesc": "Привязанный клиент отображается здесь. С привязанным клиентом можно сохранить заказ и поделиться ссылкой на живое предложение — или оформить заказ от его имени.",
                    "fltCartCreateOrderTitle": "Сохранить и поделиться предложением", "fltCartCreateOrderDesc": "Нажмите «Сохранить предложение», когда будете готовы — это доступно только после привязки клиента. После сохранения создаётся ссылка на живое предложение: когда клиент открывает её, цены обновляются автоматически, а доступность отражается в реальном времени. При желании можно отправить предложение и без живой ссылки.",
                    "fltCartComparePriceTitle": "Сравнить цены", "fltCartComparePriceDesc": "Нажмите, чтобы сравнить цену рейса у других поставщиков и найти наиболее выгодный вариант.",
                    "fltCartTotalTitle": "Итоговая цена", "fltCartTotalDesc": "Общая цена показана здесь — включая все товары и вашу комиссию. Когда будете готовы, сохраните заказ как предложение для отправки клиенту или нажмите «Перейти к оплате» для перехода к оформлению.",
                    "fltCartActionTitle": "Перейти к оплате", "fltCartActionDesc": "Нажмите «Перейти к оплате» для оформления заказа и заполнения данных пассажиров.",
                    "fltCartSaveOfferActionTitle": "Сохраните предложение, чтобы завершить", "fltCartSaveOfferActionDesc": "Нажмите «Сохранить предложение», чтобы создать живую ссылку на предложение и завершить этот шаг. Вы можете поделиться ссылкой с клиентом в любое время — цены и наличие обновляются в реальном времени.",
                    "fltCheckoutCartTitle": "Сводка заказа", "fltCheckoutCartDesc": "Левая панель показывает выбранный рейс и общую сумму к оплате.",
                    "fltCheckoutCustomerInfoTitle": "Информация о клиенте", "fltCheckoutCustomerInfoDesc": "Заполните личные данные заказчика в этом разделе.",
                    "fltCheckoutFirstNameTitle": "Имя", "fltCheckoutFirstNameDesc": "Введите имя заказчика точно как в удостоверении личности или паспорте.",
                    "fltCheckoutLastNameTitle": "Фамилия", "fltCheckoutLastNameDesc": "Введите фамилию заказчика точно как в удостоверении личности или паспорте.",
                    "fltCheckoutPhoneTitle": "Номер телефона", "fltCheckoutPhoneDesc": "Действующий номер телефона необходим для отправки подтверждения заказчику.",
                    "fltCheckoutEmailTitle": "Email-адрес", "fltCheckoutEmailDesc": "Введите email заказчика для получения подтверждения бронирования и электронных билетов.",
                    "fltCheckoutGuestInfoTitle": "Данные пассажиров", "fltCheckoutGuestInfoDesc": "Введите полное имя, номер паспорта и дату рождения каждого пассажира точно как в паспорте.",
                    "fltCheckoutTCTitle": "Условия и согласие", "fltCheckoutTCDesc": "Прочитайте и примите условия бронирования перед отправкой заказа.",
                    "fltCheckoutFormTitle": "Данные пассажиров", "fltCheckoutFormDesc": "Введите полное имя, номер паспорта и дату рождения каждого пассажира точно как в паспорте.",
                    "fltCheckoutActionTitle": "Подтвердить заказ", "fltCheckoutActionDesc": "Нажмите «Отправить и перейти к оплате» для подтверждения данных пассажиров и перехода к оплате.",
                    "abBannerTitle": "Панель агента",
                    "abBannerDesc": "Эта полоса в верхней части B2C — ваша эксклюзивная панель управления агента. Она даёт быстрый доступ к управлению клиентами, настройкам цен, балансу Diamonds и аккаунту.",
                    "abExchangeTitle": "Курсы валют в реальном времени",
                    "abExchangeDesc": "Актуальные курсы валют отображаются здесь для быстрой справки при работе с бронированиями в нескольких валютах.",
                    "abOnboardingBtnTitle": "Руководство по онбордингу",
                    "abOnboardingBtnDesc": "Нажмите на значок вопроса в любой момент, чтобы снова открыть руководство по онбордингу и вернуться к любому шагу.",
                    "abSwitchersTitle": "Переключатели режима работы",
                    "abSwitchersDesc": "Два переключателя: режим агента/клиента — в режиме агента видны опции комиссии и цены только для агентов. Цена брутто/нетто — переключение между розничной и чистой ценой.",
                    "abCustomerSearchTitle": "Поиск клиента",
                    "abCustomerSearchDesc": "Ищите существующего клиента по имени или данным. Выбор клиента привязывает его к текущему бронированию, чтобы заказ отображался в его аккаунте и управлялся из бэк-офиса.",
                    "abUpgradePlanTitle": "Обновить тариф",
                    "abUpgradePlanDesc": "Эта кнопка появляется, когда агентство на тарифе Light или Regular. Нажмите, чтобы открыть диалог обновления тарифа и разблокировать расширенные функции.",
                    "abDiamondsTitle": "Баланс Diamonds",
                    "abDiamondsDesc": "Ваш кешбэк-баланс в Diamonds отображается здесь. Сумма включает подтверждённые доходы плюс будущие ожидаемые вознаграждения. Наведите курсор для детализации.",
                    "abUserMenuTitle": "Ваш аккаунт",
                    "abUserMenuDesc": "Нажмите на своё имя, чтобы открыть меню аккаунта — просмотр профиля, статуса тарифа агентства и выход из системы. Нажмите «Завершить» для выполнения этого шага.",
                    "pkgResSearchActionTitle": "Найти пакет",
                    "pkgResSearchActionDesc": "Заполните детали поездки выше и нажмите «Поиск», чтобы увидеть доступные пакеты.",
                    "pkgResOverviewTitle": "Результаты поиска",
                    "pkgResOverviewDesc": "Здесь вы видите все доступные пакеты, соответствующие вашему запросу. Каждая карточка показывает отель, даты, цену и включённые рейсы.",
                    "pkgResSideFiltersTitle": "Фильтрация результатов",
                    "pkgResSideFiltersDesc": "Используйте боковые фильтры для сужения результатов по цене, направлению, звёздности отеля и другим параметрам.",
                    "pkgResCardTitle": "Карточка пакета",
                    "pkgResCardDesc": "Каждая карточка показывает название отеля, даты поездки, рейсы, включённые дополнения и цену на человека. Нажмите «К заказу» для просмотра полных деталей.",
                    "pkgResActionTitle": "Открыть детали пакета",
                    "pkgResActionDesc": "Нажмите «К заказу» на любой карточке пакета, чтобы открыть полные детали в новой вкладке и выбрать номер.",
                    "pkgPageHotelTitle": "Информация об отеле",
                    "pkgPageHotelDesc": "Этот раздел показывает всё об отеле в пакете — фотографии, название, звёздность и даты бронирования.",
                    "pkgPageGalleryTitle": "Фотографии отеля",
                    "pkgPageGalleryDesc": "Просматривайте галерею отеля — нажмите на любое фото для открытия полноэкранного просмотра всех изображений.",
                    "pkgPageDetailsTitle": "Название и рейтинг отеля",
                    "pkgPageDetailsDesc": "Здесь отображается название отеля, направление, количество звёзд, даты поездки и общая продолжительность пребывания.",
                    "pkgPageIncludesTitle": "Что включено",
                    "pkgPageIncludesDesc": "В этой области перечислено всё, что входит в стоимость пакета — перелёты, трансферы, мероприятия и билеты на события.",
                    "pkgPageFlightsTitle": "Детали рейса",
                    "pkgPageFlightsDesc": "В этом разделе показаны рейсы туда и обратно, включённые в пакет — авиакомпания, время и маршрут.",
                    "pkgPageRoomsTitle": "Выбор номера",
                    "pkgPageRoomsDesc": "Ниже представлены все доступные типы номеров для этого пакета. Сравните варианты по цене, типу питания и характеристикам номера.",
                    "pkgPageRoomFiltersTitle": "Фильтры номеров",
                    "pkgPageRoomFiltersDesc": "Используйте фильтры для сужения вариантов по числу гостей, типу питания (завтрак, полупансион, всё включено) или названию номера.",
                    "pkgPageRoomCardTitle": "Карточка номера",
                    "pkgPageRoomCardDesc": "Каждая карточка содержит фото, название номера и доступные удобства. Прокрутите вниз для просмотра всех строк с ценами.",
                    "pkgPageRoomPriceTitle": "Цена и тип питания",
                    "pkgPageRoomPriceDesc": "Каждая строка показывает тип питания, политику отмены, что включено и итоговую цену. Выберите подходящий вариант для клиента.",
                    "pkgPageAddToCartTitle": "Добавить номер в корзину",
                    "pkgPageAddToCartDesc": "Нажмите «Добавить к заказу» на выбранном номере, чтобы добавить пакет в корзину и продолжить к оплате.",
                    "moOrderIdTitle": "Номер заказа",
                    "moOrderIdDesc": "Номер вашего заказа отображается здесь. Используйте его для быстрого обращения к бронированию при контакте с поддержкой или отслеживании.",
                    "moCartOverviewTitle": "Сводка бронирования",
                    "moCartOverviewDesc": "Левая панель показывает полную сводку вашего бронирования — все забронированные продукты, детали цен и доступные действия.",
                    "moCartProductsTitle": "Забронированные продукты",
                    "moCartProductsDesc": "Каждый пункт вашего заказа указан здесь — детали рейса, тип номера, даты и количество пассажиров. Проверьте все продукты перед внесением изменений.",
                    "moCartAgentTitle": "Опции агента",
                    "moCartAgentDesc": "Как агент, вы можете скорректировать свою комиссию по этому заказу — установите процент или фиксированную сумму на человека. Изменения обновляют итоговую цену, отображаемую клиенту.",
                    "moCartTotalTitle": "Итого по заказу",
                    "moCartTotalDesc": "Общая сумма к оплате отображается в нижней части корзины. Проверьте её внимательно — она отражает все продукты плюс применённую комиссию агента.",
                    "moTitleAreaTitle": "Действия на странице",
                    "moTitleAreaDesc": "Верхняя часть формы показывает заголовок страницы. Кнопка «Перейти к оплате» позволяет перейти к шагу оплаты после проверки и обновления данных заказа.",
                    "moPaymentBtnTitle": "Перейти к оплате",
                    "moPaymentBtnDesc": "Нажмите эту кнопку, когда все данные заказа заполнены и верны. Вы будете перенаправлены в раздел оплаты, где сможете выбрать способ оплаты и завершить бронирование.",
                    "moFormTitle": "Форма данных заказа",
                    "moFormDesc": "Эта форма позволяет просматривать и обновлять все данные заказа — информацию о клиенте, имена гостей, данные паспорта и особые пожелания. Заполните все обязательные поля перед переходом к оплате."
                },
                "guideExplorer": {
                    "title": "Проводник по функциям",
                    "subtitle": "Изучайте функции в своём темпе",
                    "startBtn": "Начать",
                    "doneLabel": "Готово",
                    "noSiteTooltip": "Требуется настроенный сайт",
                    "timesCompleted": "раз выполнено",
                    "filtersTitle": "Фильтры"
                },
            },
            "bot": {
                "title": "Sky360 Туристический помощник",
                "newChat": "Новый чат",
                "previewCart": "Просмотр корзины",
                "addingToCart": "Добавляем в корзину…",
                "blocked": "Этот чат отключён.",
                "reconnecting": "Переподключение…",
                "connectionError": "Ошибка соединения — повтор…",
                "emptyState": {
                    "title": "Как я могу помочь спланировать ваш отдых?",
                    "subtitle": "Спросите о рейсах, отелях, пакетах или активностях."
                },
                "input": {
                    "placeholder": "Задайте любой вопрос о вашем путешествии…",
                    "disabled": "Чат отключён"
                },
                "itinerary": {
                    "titleOne": "1 позиция · {{total}}",
                    "titleOther": "{{count}} позиции · {{total}}",
                    "total": "Итого",
                    "remove": "Удалить"
                },
                "checkout": {
                    "title": "Ваш маршрут",
                    "travellers": "Путешественники",
                    "total": "Итого",
                    "confirmBook": "Подтвердить и заказать",
                    "completeBooking": "Завершить бронирование"
                },
                "result": {
                    "select": "Выбрать",
                    "direct": "Прямой",
                    "stopsOne": "1 пересадка",
                    "stopsOther": "{{count}} пересадки",
                    "freeCancellation": "Бесплатная отмена",
                    "return": "Обратно",
                    "nights": "ночей",
                    "perNight": "/ночь"
                }
            },
            "changeApproval": {
                "greeting": "Здравствуйте",
                "subtitle": "Ваш рейс был изменён",
                "changeTableTitle": "Детали изменения",
                "colField": "Поле",
                "colBefore": "До",
                "colAfter": "После",
                "confirmPrompt": "Пожалуйста, подтвердите, что вы осведомлены об этом изменении.",
                "confirmBtn": "Подтвердить изменение",
                "declineBtn": "Отклонить",
                "expiresLabel": "Действует до",
                "expiresIn": "Ссылка истекает через",
                "confirmedTitle": "Изменение подтверждено",
                "confirmedMsg": "Вы подтвердили изменение",
                "declinedTitle": "Изменение отклонено",
                "declinedMsg": "Вы отклонили изменение. Наша команда свяжется с вами.",
                "expiredTitle": "Ссылка устарела",
                "expiredMsg": "Срок действия ссылки истёк. Пожалуйста, свяжитесь с поддержкой.",
                "failedTitle": "Ссылка недоступна",
                "failedMsg": "Ссылка недоступна. Пожалуйста, свяжитесь с поддержкой.",
                "errorBanner": "Произошла ошибка. Пожалуйста, попробуйте ещё раз.",
                "loading": "Загрузка...",
                "days": "дн.",
                "hours": "ч.",
                "minutes": "мин."
            }
        }
    }
};

export default translationsRu;